(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('lodash'), require('moment'), require('axios'), require('lang.js'), require('vue')) :
    typeof define === 'function' && define.amd ? define(['exports', 'lodash', 'moment', 'axios', 'lang.js', 'vue'], factory) :
    (global = global || self, factory(global['piweb-lib-vue'] = {}, global.lodash, global.moment, global.axios, global.lang.js, global.Vue));
}(this, function (exports, lodash, moment, axios, Lang, Vue) { 'use strict';

    function ___$insertStyle(css) {
      if (!css) {
        return;
      }
      if (typeof window === 'undefined') {
        return;
      }

      var style = document.createElement('style');

      style.setAttribute('type', 'text/css');
      style.innerHTML = css;
      document.head.appendChild(style);
      return css;
    }

    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    axios = axios && axios.hasOwnProperty('default') ? axios['default'] : axios;
    Lang = Lang && Lang.hasOwnProperty('default') ? Lang['default'] : Lang;
    Vue = Vue && Vue.hasOwnProperty('default') ? Vue['default'] : Vue;

    var obj;
    //valores correpondentes a 'SIM' e 'NÃO'
    var SIM = 'S';
    var NAO = 'N';

    var constantes = Object.freeze({
        PACKAGE: 'piweb-lib-vue',
        LOCALE: 'pt-BR',
        BASE_URL: window.location.protocol+'//'+window.location.host,

        icon: {
            success: 'check-circle',
            danger: 'exclamation-circle',
            warning: 'exclamation-triangle',
            info: 'info-circle',
        },
        mask: {
            CEP: '##.###-###',
            CPF: '###.###.###-##',
            CPF_CNPJ: ['###.###.###-##', '##.###.###/####-##'],
            CNPJ: '##.###.###/####-##',
            TELEFONE: ['(##)####-####','(##)#####-####'],
            DATE: '##/##/####',
            PROTOCOLO_SIASP: ['#######-###', '#######-###/####'],
            HORA: '##:##',
        },
        //essa constante determina qual mensagem do laravel corresponde a cada tipo de validação do vuelidate. Somente para as que não coincidem.
        msgTypeMap: {
            alphaNum: 'alpha_num',
            between: 'between.numeric',
            minLength: 'min.string',
            minValue: 'min.numeric', 
            maxLength: 'max.string',
            maxValue: 'max.numeric',
            // requiredIf: { key: 'required_with', params: { prop: 'values' }, ref: 'values' },
            requiredIf: 'required',
            requiredUnless: 'required',
            required_with: { ref: 'values' },
            sameAs: { key: 'same', params: { eq: 'other' }, ref: 'other' },
        },
        //usado como valor/descrição de options para campos que podem ser SIM ou NÃO
        SIM_NAO: ( obj = {}, obj[SIM] = 'Sim', obj[NAO] = 'Não', obj ),
        SIM_NAO_ARRAY: [
            {value: SIM, text: 'Sim'},
            {value: NAO, text: 'Não'}
        ],    
        SIM: SIM,
        NAO: NAO,
        UF: {
            AC: 'Acre',
            AL: 'Alagoas',
            AP: 'Amapá',
            AM: 'Amazonas',
            BA: 'Bahia',
            CE: 'Ceará',
            DF: 'Distrito Federal',
            ES: 'Espírito Santo',
            GO: 'Goiás',
            MA: 'Maranhão',
            MT: 'Mato Grosso',
            MS: 'Mato Grosso do Sul',
            MG: 'Minas Gerais',
            PA: 'Pará',
            PB: 'Paraíba',
            PR: 'Paraná',
            PE: 'Pernambuco',
            PI: 'Piauí',
            RJ: 'Rio de Janeiro',
            RN: 'Rio Grande do Norte',
            RS: 'Rio Grande do Sul',
            RO: 'Rondônia',
            RR: 'Roraima',
            SC: 'Santa Catarina',
            SP: 'São Paulo',
            SE: 'Sergipe',
            TO: 'Tocantins',
        },
        unidade_medida: {
            m: "m",
            m2: "m<sup>2</sup>",
            unidades: "unid.",
            real: "R$",
        },
        placeholder: {
            int: "0",
            decimal: "0,00",
            date: "dd/mm/aaaa",
            select: "Selecione",
            naoAplica: "Não se aplica",        
        },
        /**
         * Lista de mime types mais comuns e respectivas extensões. Se for necessário uma lista maior, acrescente aqui ou 
         * considere utilizar um pacote do npm (https://www.npmjs.com/package/) como "mime-db" ou "myme-types"
         */
        mime_types: {
            "application/json": "json",
            "application/msword": "doc",
            "application/pdf": "pdf",
            "application/vnd.ms-excel": "xls",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
            "text/csv": "csv",
            "text/html": "html",
            "text/plain": "txt",
        }
    });

    //

    var script = {
        props: {
            mensagens: { type: Array, default: function () { return []; } },
            hasIcon: { type: Boolean, default: true },
            variant: { type: String, default: 'info' },
            dismissible: { type: Boolean, default: false },
            dismissLabel: { type: String, default: 'Fechar' },
            value: { type: Boolean, default: true },
        },
        data: function data() {
            return { 
                icon: constantes.icon,
            }
        },
    };

    function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
    /* server only */
    , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
      if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
      } // Vue.extend constructor export interop.


      var options = typeof script === 'function' ? script.options : script; // render functions

      if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true; // functional template

        if (isFunctionalTemplate) {
          options.functional = true;
        }
      } // scopedId


      if (scopeId) {
        options._scopeId = scopeId;
      }

      var hook;

      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true

          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          } // inject component styles


          if (style) {
            style.call(this, createInjectorSSR(context));
          } // register component module identifier for async chunk inference


          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        }; // used by ssr in case component is cached and beforeCreate
        // never gets called


        options._ssrRegister = hook;
      } else if (style) {
        hook = shadowMode ? function () {
          style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
        } : function (context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook) {
        if (options.functional) {
          // register for functional component in vue file
          var originalRender = options.render;

          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return script;
    }

    var normalizeComponent_1 = normalizeComponent;

    var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
    function createInjector(context) {
      return function (id, style) {
        return addStyle(id, style);
      };
    }
    var HEAD = document.head || document.getElementsByTagName('head')[0];
    var styles = {};

    function addStyle(id, css) {
      var group = isOldIE ? css.media || 'default' : id;
      var style = styles[group] || (styles[group] = {
        ids: new Set(),
        styles: []
      });

      if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

          code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
        }

        if (!style.element) {
          style.element = document.createElement('style');
          style.element.type = 'text/css';
          if (css.media) { style.element.setAttribute('media', css.media); }
          HEAD.appendChild(style.element);
        }

        if ('styleSheet' in style.element) {
          style.styles.push(code);
          style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
        } else {
          var index = style.ids.size - 1;
          var textNode = document.createTextNode(code);
          var nodes = style.element.childNodes;
          if (nodes[index]) { style.element.removeChild(nodes[index]); }
          if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }else { style.element.appendChild(textNode); }
        }
      }
    }

    var browser = createInjector;

    /* script */
    var __vue_script__ = script;

    /* template */
    var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":_vm.variant,"show":_vm.value,"dismissible":_vm.dismissible,"dismiss-label":_vm.dismissLabel},on:{"dismissed":function($event){return _vm.$emit('input', false)}}},[_c('div',{staticClass:"row"},[(_vm.hasIcon && _vm.icon[_vm.variant])?_c('div',{staticClass:"col-1 align-self-center px-2 icon-col d-none d-sm-flex"},[_c('i',{class:'fa fa-2x'+(_vm.icon[_vm.variant]?' fa-'+_vm.icon[_vm.variant]:'')+' mx-auto'})]):_vm._e(),_c('div',{staticClass:"col align-self-center pr-0"},[(_vm.mensagens.length>1)?_c('ul',{staticClass:"mb-0"},_vm._l((_vm.mensagens),function(msg,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(msg)}})}),0):_c('span',{domProps:{"innerHTML":_vm._s(_vm.mensagens[0])}}),_vm._t("default")],2)])])};
    var __vue_staticRenderFns__ = [];

      /* style */
      var __vue_inject_styles__ = function (inject) {
        if (!inject) { return }
        inject("data-v-3d456beb_0", { source: ".icon-col{min-width:2.2em}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__ = undefined;
      /* module identifier */
      var __vue_module_identifier__ = undefined;
      /* functional template */
      var __vue_is_functional_template__ = false;
      /* style inject SSR */
      

      
      var alert = normalizeComponent_1(
        { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
        __vue_inject_styles__,
        __vue_script__,
        __vue_scope_id__,
        __vue_is_functional_template__,
        __vue_module_identifier__,
        browser,
        undefined
      );

    //

    var script$1 = {
        props: {
            value: String,
            state: { type: Boolean, default: null },
            dados: {
                type: Array,
                default: function () { return []; }
            },
            urlDados: String,
            functionJquery: Function,
            function: Function,
            keyText: {
                type: String,
                default: 'text'
            },
            keyId: {
                type: String,
                default: 'value'
            },
            //aplicável somente se os dados foram fornecidos via parâmetro 'dados' (buscas por URL e funções seguem a própria lógica)
            ignoreCase: {
                type: Boolean,
                default: true
            },
            //Tamanho mínimo da string de busca (começa a busca somente a partir desse tamanho)
            minSearchSize: {
                type: Number,
                default: 1
            },
            //Ativa automaticamente o primeiro item da lista sempre que ela é atualizada
            activeFirst: {
                type: Boolean,
                default: true
            },
            //Se deve permitir que o usuário insira um texto que não foi encontrado na lista
            allowAny: {
                type: Boolean,
                default: true
            }
        },
        data: function data() {
            return {
                items: [],
                active_index: -1,
                selected_item: -1,
                focused: false,
                show_list: false,
                inner_value: this.value,
                blur_timeout: undefined,
            }
        },
        watch: {
            value: function value() {
                this.inner_value = this.value;
            },
            items: function items() {
                //sempre que a lista é atualizada, desmarca o item selecionado anteriormente
                this.active_index = this.activeFirst ? 0 : -1;
            },
            focused: function focused(valor) {
                if(!valor) { $(this.$el).find('input').trigger('blur'); }
                else { this.active_index = this.activeFirst ? 0 : -1; }
            },
        },
        methods: {
            setValue: function setValue(valor) {
                this.inner_value = valor;
                //se tinha selecionado um item da lista, mas mudou o texto do campo para um valor diferente do texto desse item
                if(this.items[this.selected_item] && this.items[this.selected_item][this.keyText] !== valor) {
                    this.selected_item = -1;
                }
                this.$emit('input', valor);
                this.search(valor);
            },
            /**
             * Emite o último item selecionado
             * @param {Number} i índice do item selecionado na lista. default = -1 = não selecionar da lista.
            */
            selectItem: function selectItem(i) {
                var obj;

                if ( i === void 0 ) i = -1;
                var item = (i!==-1 && this.items[i]) 
                    //selecionou um item da lista
                    ? Object.assign({}, this.items[i])
                    //informou texto arbitrário
                    : ( obj = {}, obj[this.keyText] = this.allowAny ? this.inner_value : '', obj );

                this.inner_value = item.text;
                //this.selected_item = item;
                this.selected_item = i;

                this.$emit('input', item.text);
                this.$emit('selected', item);
            },
            /**
             * Consulta os itens que contêm o texto pesquisado.
             * Utiliza a função debounce do lodash para evitar chamadas consecutivas num curto período.
            */
            search: lodash.debounce(function(str) {
                var this$1 = this;


                if(this.focused)
                {
                    if(str && str.length >= this.minSearchSize)
                    {
                        //console.log('search', str);
                        if(this.functionJquery) {
                            this.functionJquery(str)
                            .done(function (response) { this$1.items = response; }) 
                            .fail();
                        } else if(this.function) {
                            this.function(str)
                            .then(function (response) { this$1.items = response.data.data; }) 
                            .catch();
                        } else if(this.urlDados) {
                            this.$api.
                            getFonteDados(this.urlDados, str, false)
                            .then(function (response) { this$1.items = response; })
                            .catch();
                        } else {
                            if(this.ignoreCase) {
                                str = str.toUpperCase();
                                this.items = this.dados.filter(function (item) {
                                    return item[this$1.keyText].toUpperCase().indexOf(str) !== -1;
                                });
                            } else {
                                this.items = this.dados.filter(function (item) {
                                    return item[this$1.keyText].indexOf(str) !== -1;
                                });
                            }
                        }
                    } else {
                        this.items = [];
                    }
                }
            }, 500),
            /**
             * Seleciona o item especificado pelo índice
             * @param {number} i índice do item
             * 
            */
            select: function select(i) {
                this.selectItem(i);
                this.focused = false;
            },
            /**
             * Atrasa o evento blur do input interno.
            */
            inputBlur: function inputBlur() {
                var this$1 = this;

                //previne dois disparos sequenciais de blur
                if(!this.blur_timeout) {
                    this.blur_timeout = window.setTimeout(function () {
                        //console.log('inputBlur executado');
                        this$1.focused = false;
                        this$1.show_list = false;
                        this$1.blur_timeout = undefined;
                        //Se não selecionou valor na lista
                        if(this$1.selected_item === -1)
                            { this$1.selectItem(); }
                        //this.items = [];
                    }, 200);
                }
            },
            inputFocus: function inputFocus() {
                this.focused = true;
                this.show_list = true;
                if(this.blur_timeout) {
                    window.clearTimeout(this.blur_timeout);
                    this.blur_timeout = undefined;
                }
            },
            /**
            * Marca o próximo item da lista. Não seleciona, apenas marca para seleção.
            */
            next: function next() {
                this.active_index = (this.active_index+1) % this.items.length;
            },
            /**
            * Marca o item anterior da lista. Não seleciona, apenas marca para seleção.
            */
            previous: function previous() {
                var atual = (this.active_index < 1) ? this.items.length : this.active_index;
                this.active_index = atual -1;
            }
        },
    };

    /* script */
    var __vue_script__$1 = script$1;

    /* template */
    var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"value":_vm.inner_value,"state":_vm.state},on:{"input":_vm.setValue},nativeOn:{"focus":function($event){return _vm.inputFocus($event)},"blur":function($event){return _vm.inputBlur($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.previous($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.next($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.select(_vm.active_index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();_vm.active_index = -1;}]}}),_c('div',{staticClass:"list-box"},[_c('b-list-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_list),expression:"show_list"}]},_vm._l((_vm.items),function(item,i){return _c('b-list-group-item',{key:item[_vm.keyId],attrs:{"button":"","active":i === _vm.active_index},domProps:{"innerHTML":_vm._s(item[_vm.keyText])},on:{"click":function($event){return _vm.select(i)}}})}),1)],1)],1)};
    var __vue_staticRenderFns__$1 = [];

      /* style */
      var __vue_inject_styles__$1 = function (inject) {
        if (!inject) { return }
        inject("data-v-2e4663bf_0", { source: ".list-box[data-v-2e4663bf]{height:0;overflow:visible}.list-box .list-group-item[data-v-2e4663bf]{z-index:1}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__$1 = "data-v-2e4663bf";
      /* module identifier */
      var __vue_module_identifier__$1 = undefined;
      /* functional template */
      var __vue_is_functional_template__$1 = false;
      /* style inject SSR */
      

      
      var autocomplete = normalizeComponent_1(
        { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
        __vue_inject_styles__$1,
        __vue_script__$1,
        __vue_scope_id__$1,
        __vue_is_functional_template__$1,
        __vue_module_identifier__$1,
        browser,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$2 = {
        props: {
            options: {
                type: Array,
                default: function () { return []; },
            },
            state: {
                type: Boolean,
                default: null,
            },
            value: {
                type: Array,
                default: function (){ return []; },
            },
            bordered: {
                type: Boolean,
                default: true,
            },
            showEmpty: {
                type: Boolean,
                default: true,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
            emptyText: {
                type: String,
                default: "Nenhum item adicionado",
            },
            responsive: false,
            keyText: {
                type: String,
                default: "text",
            },
            keyId: {
                type: String,
                default: "value",
            },
            fields: {
                type: Array,
                default: function (){ return [
                    { key: 'text', label: 'Item' } ]; }
            },
            tableClass: { 
                type: String,
                default: ""
            },
            hover:  { 
                type: Boolean, 
                default: true
            },
        },
        data: function data(){
            return {
                valores_selecionados: [],
                autocompletelist_search: '',
            }
        },
        methods: {
            selecionar: function selecionar(item) {
                var this$1 = this;
     
                if(item[this.keyId] && !_.find(this.valores_selecionados,function (i){
                    return i[this$1.keyId] == item[this$1.keyId]; 
                }))
                {
                    this.valores_selecionados.push(item);
                    this.$emit('input',this.valores_selecionados);
                }
                this.autocompletelist_search = '';
            },
            remover: function remover(indice) {                 
                this.valores_selecionados.splice(indice,1);
            },     
        },
        computed:{
            table_fields: function table_fields(){
                return ( this.fields ).concat( [{ key: 'actions', label: 'Opções', class: 'text-center align-middle' }]);
            }
        },

        watch: {
            value: function value(value$1) {
                this.valores_selecionados = value$1;
            }
        },
    };

    /* script */
    var __vue_script__$2 = script$2;

    /* template */
    var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-input-group',{staticClass:"w-100 mb-2"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})]),_c('autocomplete',{staticClass:"flex-1",attrs:{"dados":_vm.options,"state":_vm.state,"allow-Any":false,"key-text":_vm.keyText,"key-id":_vm.keyId},on:{"selected":_vm.selecionar},model:{value:(_vm.autocompletelist_search),callback:function ($$v) {_vm.autocompletelist_search=$$v;},expression:"autocompletelist_search"}})],1),_c('b-table',{staticClass:"tabelaConsulta",class:_vm.tableClass,attrs:{"items":_vm.valores_selecionados,"fields":_vm.table_fields,"empty-text":_vm.emptyText,"show-empty":_vm.showEmpty,"thead-class":_vm.value.length  ? '' : 'd-none',"hover":_vm.hover,"bordered":_vm.bordered,"small":"","striped":"","responsive":_vm.responsive},on:{"row-clicked":function($event){return _vm.$emit('row-clicked', $event)}},scopedSlots:_vm._u([{key:"actions",fn:function(row){return [_c('b-link',{attrs:{"variant":"danger","title":"remover item da lista"},on:{"click":function($event){$event.stopPropagation();return _vm.remover(row.index)}}},[_c('i',{staticClass:"fa fa-trash fa-lg",attrs:{"aria-hidden":"true"}})])]}},{key:"campoExtra1",fn:function(data){return [_vm._t("campoExtra1",null,null,data)]}},{key:"row-details",fn:function(row){return [_vm._t("row-details",null,null,row)]}}],null,true)})],1)};
    var __vue_staticRenderFns__$2 = [];

      /* style */
      var __vue_inject_styles__$2 = undefined;
      /* scoped */
      var __vue_scope_id__$2 = undefined;
      /* module identifier */
      var __vue_module_identifier__$2 = undefined;
      /* functional template */
      var __vue_is_functional_template__$2 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var autocompletelist = normalizeComponent_1(
        { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
        __vue_inject_styles__$2,
        __vue_script__$2,
        __vue_scope_id__$2,
        __vue_is_functional_template__$2,
        __vue_module_identifier__$2,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$3 = {
        props: {
            //percentual de progresso
            percentage: {
                type: Number,
                default: 0,
            },
            //se deve exibir o número com o percentual de progresso
            showNumber: {
                type: Boolean,
                default: true,
            },
            //duração da animação de mudança no percentual
            duration: {
                type: Number,
                default: 800
            },
            //estilo css aplicado sobre o estilo básico dos elementos: linha de fundo, linha de progresso e texto
            bgStyle: { type: Object, default: function () {} },
            progressoStyle: { type: Object, default: function () {} },
            textStyle: { type: Object, default: function () {} },
        },

        data: function data() {
            return {
                lastPercentage: 0,
                //utilizado para exibiir o avanço do número percentual durante a animação
                percentageNumber: 0,
            }
        },

        watch: {
            percentage: function percentage(percentage$1, last) {
                this.lastPercentage = last || 0;
                this.animatePercentage(percentage$1);
            },
        },

        methods: {
            /**
             * Executa a animação de transição do percentual
            */
            animatePercentage: function animatePercentage(percentage) {
                var this$1 = this;

                var circulo = this.$el.querySelector(".circulo-progresso .progresso");
                percentage = parseFloat(percentage);

                $(circulo).animate({
                    strokeDashoffset: -50.5 -((51 / 100) * percentage)
                }, {
                    duration: this.duration,
                    progress: this.showNumber
                        ? function (animation, progress) { this$1.percentageNumber = Math.round(this$1.lastPercentage + (percentage - this$1.lastPercentage) * progress); }
                        : false
                });
            }
        },

        mounted: function mounted() {
            this.animatePercentage(this.percentage);
        }
    };

    /* script */
    var __vue_script__$3 = script$3;

    /* template */
    var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circulo-progresso"},[_c('svg',{attrs:{"viewBox":"1 1 18 18"}},[_c('circle',{staticClass:"bg",style:(_vm.bgStyle),attrs:{"cx":"10","cy":"10","r":"8"}}),_c('circle',{staticClass:"progresso",style:(_vm.progressoStyle),attrs:{"cx":"10","cy":"10","r":"8","data-percentage":_vm.percentage}})]),(_vm.showNumber)?_c('div',{staticClass:"text position-absolute",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.percentageNumber)+"%")]):_vm._e()])};
    var __vue_staticRenderFns__$3 = [];

      /* style */
      var __vue_inject_styles__$3 = undefined;
      /* scoped */
      var __vue_scope_id__$3 = undefined;
      /* module identifier */
      var __vue_module_identifier__$3 = undefined;
      /* functional template */
      var __vue_is_functional_template__$3 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var circuloprogresso = normalizeComponent_1(
        { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
        __vue_inject_styles__$3,
        __vue_script__$3,
        __vue_scope_id__$3,
        __vue_is_functional_template__$3,
        __vue_module_identifier__$3,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$4 = {
        props: {
            id: {
                type: String,
                default: '',     
            },
            value: {
                type: [ Object, Array ],
            },
            accept: {
                type: String,
                default: '',            
            },
            multiple: {
                type: Boolean,
                default: true,            
            },
            placeholder: {
                type: String,
                default: '',      
            },
            dropPlaceholder: {
                type: String,
                default: 'Solte os arquivos aqui',      
            },
            description: {
                type: String,
                default: '',      
            },
        },
        methods: {
            reset: function reset() {
                this.$refs.files.reset();
            }
        },
    };

    /* script */
    var __vue_script__$4 = script$4;

    /* template */
    var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',_vm._b({ref:"files",on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"file-name",fn:function(ref){
    var names = ref.names;
    return [_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(names[0]))]),(names.length > 1)?_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v("\n        + "+_vm._s(names.length - 1)+" arquivos\n        ")]):_vm._e()]}}])},'b-form-file',{ id: _vm.id, value: _vm.value, accept: _vm.accept, multiple: _vm.multiple, description: _vm.description, placeholder: _vm.placeholder, dropPlaceholder: _vm.dropPlaceholder },false))};
    var __vue_staticRenderFns__$4 = [];

      /* style */
      var __vue_inject_styles__$4 = undefined;
      /* scoped */
      var __vue_scope_id__$4 = undefined;
      /* module identifier */
      var __vue_module_identifier__$4 = undefined;
      /* functional template */
      var __vue_is_functional_template__$4 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var FormFileMultiplo = normalizeComponent_1(
        { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
        __vue_inject_styles__$4,
        __vue_script__$4,
        __vue_scope_id__$4,
        __vue_is_functional_template__$4,
        __vue_module_identifier__$4,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$5 = {

        props: {
            campos: Array,
            dados: Object,
            dadosAnteriores: Object,
            labelCols: {
                default: 3
            },
            marcarDiferenca: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            linhas: function linhas() {
                var this$1 = this;

                return this.campos.map(function (linha) {
                    if(Array.isArray(linha)) {
                        return linha
                            .map(function (coluna) {
                                var type = typeof coluna;
                                if(type === 'object') {
                                    //normaliza a classe da coluna para que se torne um array
                                    coluna.class = coluna.class ? (Array.isArray(coluna.class) ? coluna.class : coluna.class.split(' ')) : [];
                                    return coluna;
                                } 
                                //se for function é coluna de dados
                                else if(type === 'function') {
                                    return { type: 'data', value: coluna, class: [] }
                                }
                                //outro valor arbitrário (normalmente string, mas pode ser qualquer outro) será considerado dados ou label
                                else {
                                    return (coluna.indexOf('dados.')===0)
                                        ? { type: 'data', value: coluna, class: [] }
                                        : { type: 'label', value: coluna, class: [] };
                                }
                            })
                            .map(function (coluna) {
                                var col = Object.assign({}, coluna);
                                //se não especificou tipo, presume que é data
                                if(!col.type)
                                    { col.type = 'data'; }
                                //dependendo do tipo, o campo tem o valor e classe modificados
                                switch(col.type) {
                                    case 'data':
                                        col.value = this$1.valorColunaDado(col);
                                        if(col.class[0] !== 'grid-data')
                                            { col.class.unshift('grid-data', 'col'); }
                                        break;
                                    case 'label':
                                        col.value = this$1.__('attributes.'+col.value, null, col.value ? col.value : '');
                                        if(col.class[0] !== 'grid-label')
                                            { col.class.unshift('grid-label', 'col-md-'+this$1.labelCols); }
                                        break;
                                    case 'header':
                                        col.value = this$1.__('attributes.'+col.value, null, col.value);
                                        if(col.class[0] !== 'grid-header')
                                            { col.class.unshift('grid-header', 'col'); }
                                        break;
                                    default:
                                        if(col.class[0] !== 'col')
                                            { col.class.unshift('col'); }
                                }
                                return col;
                            });
                    } else {
                        //se a linha é apenas uma string, ela é tratada como header
                        return [ { type: 'header', value: this$1.__('attributes.'+linha, null, linha), class: [ "col", "grid-header" ] } ];
                    }
                });
            }
        },

        methods: {
            /** 
             * retorna o valor de um campo de dados
             * 
             * @param Object col Especificação do campo de dados 
             */
            valorColunaDado: function valorColunaDado(col) {
                var tipo_valor = typeof col.value;
                //verifica se o valor da coluna foi fornecido diretamente (normalmente ele seria caminho no objeto 'dados' ou uma function)
                var valor_fixo = tipo_valor !== 'function' && (tipo_valor !== 'string' || col.value.indexOf('dados.') === -1);
                var valor = valor_fixo ? col.value : (tipo_valor === 'function' ? col.value(this.dados) : _.get(this, col.value));
                //normalmente o conteúdo retornado é apenas o novo valor da coluna
                var conteudo = (valor === '' || valor === undefined || valor === null)
                    ? ''
                    : (typeof col.filter === 'function') ? col.filter(valor) : valor;
                
                if(this.marcarDiferenca) {
                    var valor_anterior = valor_fixo 
                        ? (col.old_value) 
                        : (tipo_valor === 'function' ? col.value(this.dadosAnteriores) : _.get(this, col.value.replace('dados.', 'dadosAnteriores.')));
                    valor_anterior = (valor_anterior === null || valor_anterior === '') ? undefined : valor_anterior;

                    //se não existia um valor anterior para o campo
                    if(valor_anterior === undefined) {
                        conteudo = conteudo ? ("<span class=\"novo\">" + conteudo + "</span>") : '';
                    } 
                    //se existia um valor anterior diferente do atual
                    else if(_.trim(valor) != _.trim(valor_anterior)) {
                        conteudo = '<span class="anterior">'+(typeof col.filter === 'function' ? col.filter(valor_anterior) : valor_anterior)+'</span>'+
                                    '<span class="novo">'+conteudo+'</span>';
                    }
                }

                return conteudo;
            }
        }
    };

    /* script */
    var __vue_script__$5 = script$5;

    /* template */
    var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},_vm._l((_vm.linhas),function(row,i){return _c('div',{key:'row'+i,staticClass:"row mb-1"},_vm._l((row),function(col,j){return _c('div',{key:'col'+i+j,class:col.class},[(col.type==='slot')?[_vm._t(col.value,null,null,{ col: col })]:_c('span',{domProps:{"innerHTML":_vm._s(col.value)}})],2)}),0)}),0)};
    var __vue_staticRenderFns__$5 = [];

      /* style */
      var __vue_inject_styles__$5 = function (inject) {
        if (!inject) { return }
        inject("data-v-45310b9e_0", { source: ".grid-header{font-size:1.25rem;margin-bottom:.5rem;margin-top:1rem}.grid:first-of-type(.grid-header){margin-top:0}.grid-label{color:#6c757d}.grid-data .anterior,.grid-data .novo{display:inline-block;padding:0 2px}.grid-data .novo{background-color:#cfd}.grid-data .anterior{background-color:#fcc;color:#8b0000;text-decoration:line-through;text-decoration-color:rgba(150,0,0,.35);margin-right:.25em}.grid-data :empty{display:none}@media (min-width:768px){.grid-label{text-align:right}}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__$5 = undefined;
      /* module identifier */
      var __vue_module_identifier__$5 = undefined;
      /* functional template */
      var __vue_is_functional_template__$5 = false;
      /* style inject SSR */
      

      
      var Grid = normalizeComponent_1(
        { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
        __vue_inject_styles__$5,
        __vue_script__$5,
        __vue_scope_id__$5,
        __vue_is_functional_template__$5,
        __vue_module_identifier__$5,
        browser,
        undefined
      );

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function unwrapExports (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var withParamsBrowser = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.withParams = void 0;

    function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

    var root = typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : {};

    var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
      if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
        return maybeValidator;
      }

      return paramsOrClosure(function () {});
    };

    var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
    exports.withParams = withParams;
    });

    unwrapExports(withParamsBrowser);
    var withParamsBrowser_1 = withParamsBrowser.withParams;

    var params = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.pushParams = pushParams;
    exports.popParams = popParams;
    exports.withParams = withParams;
    exports._setTarget = exports.target = void 0;

    function _objectSpread(target) {
    var arguments$1 = arguments;
     for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i] != null ? arguments$1[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

    function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

    function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

    var stack = [];
    var target = null;
    exports.target = target;

    var _setTarget = function _setTarget(x) {
      exports.target = target = x;
    };

    exports._setTarget = _setTarget;

    function pushParams() {
      if (target !== null) {
        stack.push(target);
      }

      exports.target = target = {};
    }

    function popParams() {
      var lastTarget = target;
      var newTarget = exports.target = target = stack.pop() || null;

      if (newTarget) {
        if (!Array.isArray(newTarget.$sub)) {
          newTarget.$sub = [];
        }

        newTarget.$sub.push(lastTarget);
      }

      return lastTarget;
    }

    function addParams(params) {
      if (_typeof(params) === 'object' && !Array.isArray(params)) {
        exports.target = target = _objectSpread({}, target, params);
      } else {
        throw new Error('params must be an object');
      }
    }

    function withParamsDirect(params, validator) {
      return withParamsClosure(function (add) {
        return function () {
          var arguments$1 = arguments;

          add(params);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments$1[_key];
          }

          return validator.apply(this, args);
        };
      });
    }

    function withParamsClosure(closure) {
      var validator = closure(addParams);
      return function () {
        var arguments$1 = arguments;

        pushParams();

        try {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments$1[_key2];
          }

          return validator.apply(this, args);
        } finally {
          popParams();
        }
      };
    }

    function withParams(paramsOrClosure, maybeValidator) {
      if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
        return withParamsDirect(paramsOrClosure, maybeValidator);
      }

      return withParamsClosure(paramsOrClosure);
    }
    });

    unwrapExports(params);
    var params_1 = params.pushParams;
    var params_2 = params.popParams;
    var params_3 = params.withParams;
    var params_4 = params._setTarget;
    var params_5 = params.target;

    var withParams_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var withParams = process.env.BUILD === 'web' ? withParamsBrowser.withParams : params.withParams;
    var _default = withParams;
    exports.default = _default;
    });

    unwrapExports(withParams_1);

    var common = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "withParams", {
      enumerable: true,
      get: function get() {
        return _withParams.default;
      }
    });
    exports.regex = exports.ref = exports.len = exports.req = void 0;

    var _withParams = _interopRequireDefault(withParams_1);

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

    function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

    var req = function req(value) {
      if (Array.isArray(value)) { return !!value.length; }

      if (value === undefined || value === null) {
        return false;
      }

      if (value === false) {
        return true;
      }

      if (value instanceof Date) {
        return !isNaN(value.getTime());
      }

      if (_typeof(value) === 'object') {
        for (var _ in value) {
          return true;
        }

        return false;
      }

      return !!String(value).length;
    };

    exports.req = req;

    var len = function len(value) {
      if (Array.isArray(value)) { return value.length; }

      if (_typeof(value) === 'object') {
        return Object.keys(value).length;
      }

      return String(value).length;
    };

    exports.len = len;

    var ref = function ref(reference, vm, parentVm) {
      return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
    };

    exports.ref = ref;

    var regex = function regex(type, expr) {
      return (0, _withParams.default)({
        type: type
      }, function (value) {
        return !req(value) || expr.test(value);
      });
    };

    exports.regex = regex;
    });

    unwrapExports(common);
    var common_1 = common.regex;
    var common_2 = common.ref;
    var common_3 = common.len;
    var common_4 = common.req;

    var alpha = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.regex)('alpha', /^[a-zA-Z]*$/);

    exports.default = _default;
    });

    unwrapExports(alpha);

    var alphaNum = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

    exports.default = _default;
    });

    unwrapExports(alphaNum);

    var numeric = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.regex)('numeric', /^[0-9]*$/);

    exports.default = _default;
    });

    unwrapExports(numeric);

    var between = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(min, max) {
      return (0, common.withParams)({
        type: 'between',
        min: min,
        max: max
      }, function (value) {
        return !(0, common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
      });
    };

    exports.default = _default;
    });

    unwrapExports(between);

    var email = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

    var _default = (0, common.regex)('email', emailRegex);

    exports.default = _default;
    });

    unwrapExports(email);

    var ipAddress = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.withParams)({
      type: 'ipAddress'
    }, function (value) {
      if (!(0, common.req)(value)) {
        return true;
      }

      if (typeof value !== 'string') {
        return false;
      }

      var nibbles = value.split('.');
      return nibbles.length === 4 && nibbles.every(nibbleValid);
    });

    exports.default = _default;

    var nibbleValid = function nibbleValid(nibble) {
      if (nibble.length > 3 || nibble.length === 0) {
        return false;
      }

      if (nibble[0] === '0' && nibble !== '0') {
        return false;
      }

      if (!nibble.match(/^\d+$/)) {
        return false;
      }

      var numeric = +nibble | 0;
      return numeric >= 0 && numeric <= 255;
    };
    });

    unwrapExports(ipAddress);

    var macAddress = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default() {
      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
      return (0, common.withParams)({
        type: 'macAddress'
      }, function (value) {
        if (!(0, common.req)(value)) {
          return true;
        }

        if (typeof value !== 'string') {
          return false;
        }

        var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
        return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
      });
    };

    exports.default = _default;

    var hexValid = function hexValid(hex) {
      return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
    };
    });

    unwrapExports(macAddress);

    var maxLength = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(length) {
      return (0, common.withParams)({
        type: 'maxLength',
        max: length
      }, function (value) {
        return !(0, common.req)(value) || (0, common.len)(value) <= length;
      });
    };

    exports.default = _default;
    });

    unwrapExports(maxLength);

    var minLength = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(length) {
      return (0, common.withParams)({
        type: 'minLength',
        min: length
      }, function (value) {
        return !(0, common.req)(value) || (0, common.len)(value) >= length;
      });
    };

    exports.default = _default;
    });

    unwrapExports(minLength);

    var required = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.withParams)({
      type: 'required'
    }, common.req);

    exports.default = _default;
    });

    unwrapExports(required);

    var requiredIf = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(prop) {
      return (0, common.withParams)({
        type: 'requiredIf',
        prop: prop
      }, function (value, parentVm) {
        return (0, common.ref)(prop, this, parentVm) ? (0, common.req)(value) : true;
      });
    };

    exports.default = _default;
    });

    unwrapExports(requiredIf);

    var requiredUnless = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(prop) {
      return (0, common.withParams)({
        type: 'requiredUnless',
        prop: prop
      }, function (value, parentVm) {
        return !(0, common.ref)(prop, this, parentVm) ? (0, common.req)(value) : true;
      });
    };

    exports.default = _default;
    });

    unwrapExports(requiredUnless);

    var sameAs = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(equalTo) {
      return (0, common.withParams)({
        type: 'sameAs',
        eq: equalTo
      }, function (value, parentVm) {
        return value === (0, common.ref)(equalTo, this, parentVm);
      });
    };

    exports.default = _default;
    });

    unwrapExports(sameAs);

    var url = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    var _default = (0, common.regex)('url', urlRegex);

    exports.default = _default;
    });

    unwrapExports(url);

    var or = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default() {
      var arguments$1 = arguments;

      for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
        validators[_key] = arguments$1[_key];
      }

      return (0, common.withParams)({
        type: 'or'
      }, function () {
        var arguments$1 = arguments;

        var _this = this;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments$1[_key2];
        }

        return validators.length > 0 && validators.reduce(function (valid, fn) {
          return valid || fn.apply(_this, args);
        }, false);
      });
    };

    exports.default = _default;
    });

    unwrapExports(or);

    var and = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default() {
      var arguments$1 = arguments;

      for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
        validators[_key] = arguments$1[_key];
      }

      return (0, common.withParams)({
        type: 'and'
      }, function () {
        var arguments$1 = arguments;

        var _this = this;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments$1[_key2];
        }

        return validators.length > 0 && validators.reduce(function (valid, fn) {
          return valid && fn.apply(_this, args);
        }, true);
      });
    };

    exports.default = _default;
    });

    unwrapExports(and);

    var not = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(validator) {
      return (0, common.withParams)({
        type: 'not'
      }, function (value, vm) {
        return !(0, common.req)(value) || !validator.call(this, value, vm);
      });
    };

    exports.default = _default;
    });

    unwrapExports(not);

    var minValue = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(min) {
      return (0, common.withParams)({
        type: 'minValue',
        min: min
      }, function (value) {
        return !(0, common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
      });
    };

    exports.default = _default;
    });

    unwrapExports(minValue);

    var maxValue = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = function _default(max) {
      return (0, common.withParams)({
        type: 'maxValue',
        max: max
      }, function (value) {
        return !(0, common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
      });
    };

    exports.default = _default;
    });

    unwrapExports(maxValue);

    var integer = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.regex)('integer', /^-?[0-9]*$/);

    exports.default = _default;
    });

    unwrapExports(integer);

    var decimal = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;



    var _default = (0, common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

    exports.default = _default;
    });

    unwrapExports(decimal);

    var validators = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "alpha", {
      enumerable: true,
      get: function get() {
        return _alpha.default;
      }
    });
    Object.defineProperty(exports, "alphaNum", {
      enumerable: true,
      get: function get() {
        return _alphaNum.default;
      }
    });
    Object.defineProperty(exports, "numeric", {
      enumerable: true,
      get: function get() {
        return _numeric.default;
      }
    });
    Object.defineProperty(exports, "between", {
      enumerable: true,
      get: function get() {
        return _between.default;
      }
    });
    Object.defineProperty(exports, "email", {
      enumerable: true,
      get: function get() {
        return _email.default;
      }
    });
    Object.defineProperty(exports, "ipAddress", {
      enumerable: true,
      get: function get() {
        return _ipAddress.default;
      }
    });
    Object.defineProperty(exports, "macAddress", {
      enumerable: true,
      get: function get() {
        return _macAddress.default;
      }
    });
    Object.defineProperty(exports, "maxLength", {
      enumerable: true,
      get: function get() {
        return _maxLength.default;
      }
    });
    Object.defineProperty(exports, "minLength", {
      enumerable: true,
      get: function get() {
        return _minLength.default;
      }
    });
    Object.defineProperty(exports, "required", {
      enumerable: true,
      get: function get() {
        return _required.default;
      }
    });
    Object.defineProperty(exports, "requiredIf", {
      enumerable: true,
      get: function get() {
        return _requiredIf.default;
      }
    });
    Object.defineProperty(exports, "requiredUnless", {
      enumerable: true,
      get: function get() {
        return _requiredUnless.default;
      }
    });
    Object.defineProperty(exports, "sameAs", {
      enumerable: true,
      get: function get() {
        return _sameAs.default;
      }
    });
    Object.defineProperty(exports, "url", {
      enumerable: true,
      get: function get() {
        return _url.default;
      }
    });
    Object.defineProperty(exports, "or", {
      enumerable: true,
      get: function get() {
        return _or.default;
      }
    });
    Object.defineProperty(exports, "and", {
      enumerable: true,
      get: function get() {
        return _and.default;
      }
    });
    Object.defineProperty(exports, "not", {
      enumerable: true,
      get: function get() {
        return _not.default;
      }
    });
    Object.defineProperty(exports, "minValue", {
      enumerable: true,
      get: function get() {
        return _minValue.default;
      }
    });
    Object.defineProperty(exports, "maxValue", {
      enumerable: true,
      get: function get() {
        return _maxValue.default;
      }
    });
    Object.defineProperty(exports, "integer", {
      enumerable: true,
      get: function get() {
        return _integer.default;
      }
    });
    Object.defineProperty(exports, "decimal", {
      enumerable: true,
      get: function get() {
        return _decimal.default;
      }
    });
    exports.helpers = void 0;

    var _alpha = _interopRequireDefault(alpha);

    var _alphaNum = _interopRequireDefault(alphaNum);

    var _numeric = _interopRequireDefault(numeric);

    var _between = _interopRequireDefault(between);

    var _email = _interopRequireDefault(email);

    var _ipAddress = _interopRequireDefault(ipAddress);

    var _macAddress = _interopRequireDefault(macAddress);

    var _maxLength = _interopRequireDefault(maxLength);

    var _minLength = _interopRequireDefault(minLength);

    var _required = _interopRequireDefault(required);

    var _requiredIf = _interopRequireDefault(requiredIf);

    var _requiredUnless = _interopRequireDefault(requiredUnless);

    var _sameAs = _interopRequireDefault(sameAs);

    var _url = _interopRequireDefault(url);

    var _or = _interopRequireDefault(or);

    var _and = _interopRequireDefault(and);

    var _not = _interopRequireDefault(not);

    var _minValue = _interopRequireDefault(minValue);

    var _maxValue = _interopRequireDefault(maxValue);

    var _integer = _interopRequireDefault(integer);

    var _decimal = _interopRequireDefault(decimal);

    var helpers = _interopRequireWildcard(common);

    exports.helpers = helpers;

    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    });

    unwrapExports(validators);
    var validators_1 = validators.helpers;

    /**
     * @file Contém as validações de formulário específicas do sistema.
     * As validações contidas nesse arquivo foram implentadas no formato do pacote Vuelidate.
    */

    moment.locale(constantes.LOCALE);

    var date = validators_1.withParams({type: 'date'}, function (value) { return (value == '' || (moment(value, 'DD/MM/YYYY', true).isValid() && moment(value, 'DD/MM/YYYY', true).isSameOrBefore(moment('2999-12-31'), 'day') ) ); });

    var month = validators_1.withParams({type: 'donth'}, function (value) { return (value == '' || moment(value,'MM/YYYY').isValid()); });

    var hour = validators_1.withParams({type: 'hour'}, function (value) { return ((value == '' || moment(value, 'HH:mm', true).isValid()) && value != '24:00'); });

    function isCpf(value) {
        if(!value) { return true; }
        value = value.replace(/\D/g, '');
        if(value === '') { return true; }
        if (value.length != 11 ||
            value == "00000000000" ||
            value == "11111111111" ||
            value == "22222222222" ||
            value == "33333333333" ||
            value == "44444444444" ||
            value == "55555555555" ||
            value == "66666666666" ||
            value == "77777777777" ||
            value == "88888888888" ||
            value == "99999999999")
            { return false; }
        var add = 0;
        for (var i = 0; i < 9; i++)
            { add += parseInt(value.charAt(i)) * (10 - i); }
        var rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            { rev = 0; }
        if (rev != parseInt(value.charAt(9)))
            { return false; }
        add = 0;
        for (var i$1 = 0; i$1 < 10; i$1++)
            { add += parseInt(value.charAt(i$1)) * (11 - i$1); }
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            { rev = 0; }
        if (rev != parseInt(value.charAt(10)))
            { return false; }
        return true;
    }

    var cpf = validators_1.withParams({type: 'cpf'}, isCpf);

    function isCnpj(value) {
        if(!value) { return true; }
        var cnpj = value.replace(/[^\d]+/g,'');

        if (cnpj.length != 14)
            { return false; }

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            { return false; }

        // Valida DVs
        var len = cnpj.length - 2;
        var numeros = cnpj.substring(0,len);
        var digitos = cnpj.substring(len);
        var soma = 0, i = 0;
        var pos = len - 7;
        for (i = len; i > 0; i--) {
            soma += numeros.charAt(len - i) * pos--;
            if (pos < 2)
                { pos = 9; }
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            { return false; }

        len = len + 1;
        numeros = cnpj.substring(0,len);
        soma = 0;
        pos = len - 7;
        for (i = len; i > 0; i--) {
            soma += numeros.charAt(len - i) * pos--;
            if (pos < 2)
                { pos = 9; }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
                { return false; }

        return true;
    }

    var cnpj = validators_1.withParams({type: 'cpf'}, isCnpj);

    var cpf_cnpj = validators_1.withParams({type: 'cpf_cnpj'}, function (value) {
        var numero = value.replace(/\D/g, '');
        if(numero.length === 11)
            { return isCpf(value); }
        else
            { return isCnpj(value); }
    });

    /**
     * O campo precisa ser aceito
     * Valores tomados como aceitos: true, 'true', 'yes', 'sim', 1
    */
    var accepted = validators_1.withParams({type: 'accepted'}, function (value) {
        return value===true || [1, 'true', 'sim', 'yes'].includes(value);
    });

    //

    var script$6 = {
        props: {        
            value: {
                type: String,
                default: '',
            },
            state: {
                type: Boolean,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },        
            placeholder: {
                type: String,
                default: '',
            },
            id: String,        
        },
        data: function data() {
            return {
                datePicker: {
                    mode: "single",
                    popoverDirection: "left",
                    popoverAlign: "top",
                    paneWidth: 229,
                    themeStyles: {
                        wrapper: {
                            border: '0',
                            borderRadius: '10px',
                            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
                        },                       
                    },     
                    selectedDate: null, 
                },              
                inputDate: this.value,
            }
        },
        watch: {
            value: function value (valor) {
                var date = moment(valor, 'DD/MM/YYYY', true);     
                this.datePicker.selectedDate = date.isValid() ? date.toDate() : null;          
                this.inputDate = valor;                   
            },   
        },
        
        methods: {
            changeDate: function changeDate(newDate) {        
                this.inputDate = moment(newDate).format('DD/MM/YYYY');                           
            },         
            emitValue: function emitValue(newValue) {
                this.$emit('input', newValue);
            },
        },

        created: function created() {
            var date = moment(this.inputDate, 'DD/MM/YYYY', true);
            this.datePicker.selectedDate = date.isValid() ? date.toDate() : null;                
        }
    };

    /* script */
    var __vue_script__$6 = script$6;

    /* template */
    var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-input-group',[_c('b-input',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.$c.mask.DATE),expression:"$c.mask.DATE"}],attrs:{"value":_vm.inputDate,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_vm.emitValue}},'b-input',{id: _vm.id, state: _vm.state},false)),_c('b-input-group-text',{attrs:{"slot":"append"},slot:"append"},[(!_vm.disabled)?[_c('v-date-picker',{attrs:{"mode":_vm.datePicker.mode,"popover-direction":_vm.datePicker.popoverDirection,"popover-align":_vm.datePicker.popoverAlign,"pane-width":_vm.datePicker.paneWidth,"theme-styles":_vm.datePicker.themeStyles},on:{"input":_vm.changeDate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var inputValue = ref.inputValue;
    var updateValue = ref.updateValue;
    return _c('i',{staticClass:"fa fa-calendar fa-lg",attrs:{"aria-hidden":"true"}})}}],null,false,558939925),model:{value:(_vm.datePicker.selectedDate),callback:function ($$v) {_vm.$set(_vm.datePicker, "selectedDate", $$v);},expression:"datePicker.selectedDate"}})]:[_c('i',{staticClass:"fa fa-calendar fa-lg",attrs:{"aria-hidden":"true"}})]],2)],1)],1)};
    var __vue_staticRenderFns__$6 = [];

      /* style */
      var __vue_inject_styles__$6 = undefined;
      /* scoped */
      var __vue_scope_id__$6 = undefined;
      /* module identifier */
      var __vue_module_identifier__$6 = undefined;
      /* functional template */
      var __vue_is_functional_template__$6 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var InputDate = normalizeComponent_1(
        { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
        __vue_inject_styles__$6,
        __vue_script__$6,
        __vue_scope_id__$6,
        __vue_is_functional_template__$6,
        __vue_module_identifier__$6,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$7 = {
        props: {
            value: {
                type: [String, Number],
                default: '',
            },
            id: String,
            state: {
                type: Boolean,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            maxlength: {
                type: [String, Number],
                default: '13',
            },
            separadorMilhar: {
                type: String,
                default: '.',
            },
            separadorDecimal: {
                type: String,
                default: ',',
            },
            precisao: {
                type: [String, Number],
                default: 2,
            }
        },

        data: function data() {
            return {
                money: {
                    decimal: this.separadorDecimal,
                    thousands: this.separadorMilhar,
                    precision: this.precisao,
                    masked: false,
                },
                inner_value: this.transformaValor(this.value),
            }
        },

        watch: {
            value: function value(valor, oldValue) {
                this.inner_value = this.transformaValor(valor);
            },
        },

        computed: {
            stateClass: function stateClass() {
                if (this.state === null)
                    { return ''; }
                else
                    { return ' is-'+(this.state ? 'valid' : 'invalid'); }
            }
        },

        methods: {
            transformaValor: function transformaValor(valor) {
                var valorNumber = Number(valor);
                if(valor != valorNumber) {
                    valorNumber = Number(valor.split(this.separadorMilhar).join('').split(this.separadorDecimal).join('.'));
                }
                if (!isNaN(valorNumber)) {
                    var arrayValor = valorNumber.toString().split('.');
                    return arrayValor[0] + this.separadorDecimal + (arrayValor[1] ? arrayValor[1].substr(0, this.precisao) : '').padEnd(this.precisao, '0');
                }
                else {
                    return valor;
                }
            },

            emitValue: function emitValue(event) {
                var valorNumber = event.target.value.split(this.separadorMilhar).join('');
                this.$emit('input', valorNumber);
            },
        },
    };

    /* script */
    var __vue_script__$7 = script$7;

    /* template */
    var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],class:'form-control' + _vm.stateClass,attrs:{"id":_vm.id,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"type":"text"},domProps:{"value":_vm.inner_value},on:{"change":_vm.emitValue}})};
    var __vue_staticRenderFns__$7 = [];

      /* style */
      var __vue_inject_styles__$7 = undefined;
      /* scoped */
      var __vue_scope_id__$7 = undefined;
      /* module identifier */
      var __vue_module_identifier__$7 = undefined;
      /* functional template */
      var __vue_is_functional_template__$7 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var InputDecimal = normalizeComponent_1(
        { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
        __vue_inject_styles__$7,
        __vue_script__$7,
        __vue_scope_id__$7,
        __vue_is_functional_template__$7,
        __vue_module_identifier__$7,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$8 = {
        props: {
            id: String,
            input: { type: Object, default: function () {} },
            withReset: { type: Boolean, default: false },
            searchOnMount: { type: Boolean, default: false },
            state: { type: Boolean, default: true },
            nomeCampos: Array,
            colunaInput: String,
            msgRef: String,
            urlDados: String,
            paramsBusca: { type: Object, default: function () {} },
            colunasTabela: Array,
            dadosTab: Array,
        },
        data: function data() {
            return {
                b_show: false,
                input_value: '',
            }
        },
        watch: {
            'input.value': function input_value(valor) {
                this.input_value = valor || '';
            }
        },
        methods: {
            open: function open() {
                this.b_show = true;
            },
            close: function close() {
                this.b_show = false;
            },
            reset: function reset() {
                this.input_value = '';
                this.$emit('input', {});
            },
            setInputs: function setInputs(obj) {
                this.input_value = obj[this.colunaInput];
                this.$emit('input', obj);
            },
            busca: function busca() {
                this.$refs.modal.getData();
            }
        }
    };

    /* script */
    var __vue_script__$8 = script$8;

    /* template */
    var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.input.label,"label-for":"input"}},[_c('b-input-group',[_vm._t("camposExtra"),_c('b-form-input',{attrs:{"id":"input","state":_vm.state,"placeholder":_vm.input.placeholder,"disabled":_vm.input.disabled},on:{"input":function($event){return _vm.$emit('input-change', $event)}},nativeOn:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.open($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.reset($event)}]},model:{value:(_vm.input_value),callback:function ($$v) {_vm.input_value=$$v;},expression:"input_value"}}),_c('b-input-group-append',[_c('b-btn',{attrs:{"title":"Buscar","variant":"primary"},on:{"click":_vm.open}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":".9em"}},[_vm._v("search")])]),(_vm.withReset)?_c('b-btn',{attrs:{"title":"Limpar","variant":"warning"},on:{"click":_vm.reset}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":".9em"}},[_vm._v("clear")])]):_vm._e()],1),_c('b-input-group-append',[_vm._t("botoesExtra")],2)],2)],1),_c('modal-consulta',{ref:"modal",attrs:{"id":_vm.id,"msg-ref":_vm.msgRef,"search-on-mount":_vm.searchOnMount,"url-dados":_vm.urlDados,"params-busca":_vm.paramsBusca,"colunas-tabela":_vm.colunasTabela},on:{"row-clicked":_vm.setInputs,"hide":function($event){return _vm.$emit('hide')},"inserir-novo":function($event){return _vm.$emit('inserir-novo')},"cancelar-novo":function($event){return _vm.$emit('cancelar-novo')}},model:{value:(_vm.b_show),callback:function ($$v) {_vm.b_show=$$v;},expression:"b_show"}},[_c('div',{attrs:{"slot":"form"},slot:"form"},[_vm._t("formConsulta")],2),_c('div',{attrs:{"slot":"formNovo"},slot:"formNovo"},[_vm._t("formConsultaNovo")],2)])],1)};
    var __vue_staticRenderFns__$8 = [];

      /* style */
      var __vue_inject_styles__$8 = undefined;
      /* scoped */
      var __vue_scope_id__$8 = undefined;
      /* module identifier */
      var __vue_module_identifier__$8 = undefined;
      /* functional template */
      var __vue_is_functional_template__$8 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var InputModalConsulta = normalizeComponent_1(
        { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
        __vue_inject_styles__$8,
        __vue_script__$8,
        __vue_scope_id__$8,
        __vue_is_functional_template__$8,
        __vue_module_identifier__$8,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$9 = {
        props: {
            value: {
                type: [String],
                default: '',
            },
            id: String,
            state: {
                type: Boolean,
                default: null
            },
            hint: {
                type: String,
                default: '',
            },
            inputGroupClass: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            maxLength: {
                type: String,
                default: '18',
            },
            separadorMilhar: {
                type: String,
                default: '.',
            },
            separadorDecimal: {
                type: String,
                default: ',',
            },
        },

        data: function data() {
            return {
                money: {
                    decimal: this.separadorDecimal,
                    thousands: this.separadorMilhar,
                    precision: 2,
                    masked: false,
                },
                inputMoney: this.transformaValor(this.value),

            }
        },

        watch: {
            value: function value (valor, oldValue) {
                this.inputMoney = this.transformaValor(valor);
            },
        },

        computed: {
            stateClass: function stateClass () {
                if (this.state === null) {
                    return '';
                }
                else {
                    if (this.state) {
                        return ' is-valid';
                    }
                    else {
                        return ' is-invalid';
                    }
                }
            }
        },

        methods: {
            transformaValor: function transformaValor(valor) {
                var valorNumber = Number(valor.split(this.separadorMilhar).join('').split(this.separadorDecimal).join('.'));
                if (!isNaN(valorNumber)) {
                    var arrayValor = valorNumber.toString().split('.');
                    return arrayValor[0] + this.separadorDecimal + (arrayValor[1] ? arrayValor[1].padEnd(2, '0') : '00');
                }
                else {
                    return valor;
                }
            },

            emitValue: function emitValue(event) {
                var valorNumber = event.target.value.split(this.separadorMilhar).join('');
                this.$emit('input', valorNumber);
            },
        },
    };

    /* script */
    var __vue_script__$9 = script$9;

    /* template */
    var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'input-group' + (_vm.inputGroupClass ? ' ' + _vm.inputGroupClass : ''),attrs:{"role":"group"}},[_vm._m(0),_c('input',{directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],class:'form-control' + _vm.stateClass,attrs:{"id":_vm.id,"disabled":_vm.disabled,"maxlength":_vm.maxLength,"type":"text"},domProps:{"value":_vm.inputMoney},on:{"change":_vm.emitValue}}),(_vm.hint)?_c('div',{staticClass:"input-group-append hint"},[_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottomleft",modifiers:{"hover":true,"bottomleft":true}}],staticClass:"fa fa-question-circle fa-lg text-primary",attrs:{"aria-hidden":"true","title":_vm.hint}})])]):_vm._e()])};
    var __vue_staticRenderFns__$9 = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("R$")])])}];

      /* style */
      var __vue_inject_styles__$9 = undefined;
      /* scoped */
      var __vue_scope_id__$9 = undefined;
      /* module identifier */
      var __vue_module_identifier__$9 = undefined;
      /* functional template */
      var __vue_is_functional_template__$9 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var InputMoney = normalizeComponent_1(
        { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
        __vue_inject_styles__$9,
        __vue_script__$9,
        __vue_scope_id__$9,
        __vue_is_functional_template__$9,
        __vue_module_identifier__$9,
        undefined,
        undefined
      );

    //

    var script$a = {
        props: {
            msgRef: String,
            hasIcon: { type: Boolean, default: true },
        },
        computed: {
            mensagens: function mensagens() {
                return this.$store.getters.msgsByRef(this.msgRef);
            },
        },
        data: function data() {
            return { 
                icon: constantes.icon,
            }
        },
        methods: {
            //remove as mensages de uma classe (variant) para esse componente msgs
            limpaMensagens: function limpaMensagens(variant) {
                //anula o comportamento de ocultar b-alert, porque precisam ficar visíveis caso volte a ter mensanges no store
                this.$refs[variant][0].dismissed = false;
                //remove do store as mensagens
                this.$store.dispatch('flushMsgs', {ref: this.msgRef, variant: variant});
            }
        },
    };

    /* script */
    var __vue_script__$a = script$a;

    /* template */
    var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.msgRef}},_vm._l((_vm.mensagens),function(msgs,variant){return _c('b-alert',{key:variant,ref:variant,refInFor:true,attrs:{"variant":variant,"show":true,"dismissible":""},on:{"dismissed":function($event){return _vm.limpaMensagens(variant)}}},[_c('div',{staticClass:"row"},[(_vm.hasIcon && _vm.icon[variant])?_c('div',{staticClass:"col-1 align-self-center text-center px-2 icon-col d-none d-sm-flex"},[_c('i',{class:'fa fa-2x'+(_vm.icon[variant]?' fa-'+_vm.icon[variant]:'')+' mx-auto'})]):_vm._e(),_c('div',{staticClass:"col align-self-center pr-0"},[(msgs.length>1)?_c('ul',{staticClass:"mb-0"},_vm._l((msgs),function(msg,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(msg)}})}),0):_c('span',{domProps:{"innerHTML":_vm._s(msgs[0])}})])])])}),1)};
    var __vue_staticRenderFns__$a = [];

      /* style */
      var __vue_inject_styles__$a = function (inject) {
        if (!inject) { return }
        inject("data-v-72c6cdc2_0", { source: ".icon-col{min-width:2.2em}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__$a = undefined;
      /* module identifier */
      var __vue_module_identifier__$a = undefined;
      /* functional template */
      var __vue_is_functional_template__$a = false;
      /* style inject SSR */
      

      
      var msgs = normalizeComponent_1(
        { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
        __vue_inject_styles__$a,
        __vue_script__$a,
        __vue_scope_id__$a,
        __vue_is_functional_template__$a,
        __vue_module_identifier__$a,
        browser,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$b = {
        props: {
            id: String,
            value: { type: Boolean, default: false },
            seleciona: { type: Boolean, default: true },
            searchOnMount: { type: Boolean, default: false },
            urlDados: String,
            paramsBusca: { type: Object, default: function () {} },
            colunasTabela: Array,
            dadosTab: Array,
            msgRef: { type: String, default: 'msgFormConsulta' }

        },
        data: function data() {
           return {
               value_interno: this.value,
               perPage: 10,
               currentPage: 1,
               totalRows: 0,
               sortBy: '',
               sortDesc: '',
               dados: [],
               b_novo: false,
               gotData: false,
           }   
        },
        watch: {
            value: function value() {
                this.value_interno = this.value;
            }
        },
        methods: {
            reset: function reset() {
                this.currentPage = 1;
                this.totalRows   = 0;
                this.dados       = [];
                this.b_novo      = false;
            },
            close: function close() {
                this.$emit('input', false);
                this.$emit('hide');
                this.reset();   
            },
            click: function click($event) {
                if(this.seleciona) {
                    this.$emit('row-clicked', $event);
                    this.close();
                }
            },
            submit: function submit() {
                this.getData();
            },
            show: function show() {
                if(this.searchOnMount && Object.keys(this.paramsBusca).length) { 
                    this.getData(); 
                }
            },
            getData: function getData() {
                var this$1 = this;

                this.gotData = false;
                if(this.dadosTab && this.dadosTab.length) {
                    this.dados = this.dadosTab;
                    this.gotData = true;
                } else {
                    this.$api.getFonteDados(this.urlDados, this.paramsBusca)
                    .then(function (response) {
                        if(response.data) {
                            this$1.printMsg([]);
                            this$1.dados = response.data.data;
                            this$1.totalRows = response.data.total;
                            this$1.gotData = true;
                        } else {
                            this$1.dados = [];
                            this$1.gotData = true;
                        }
                    })
                    .catch(this.printMsg);
                }
            },
        },
        mounted: function mounted() {
        }
    };

    /* script */
    var __vue_script__$b = script$b;

    /* template */
    var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"size":"lg","id":_vm.id},on:{"show":_vm.show,"row-clicked":_vm.click,"hide":_vm.close},model:{value:(_vm.value_interno),callback:function ($$v) {_vm.value_interno=$$v;},expression:"value_interno"}},[_c('msgs',{attrs:{"msg-ref":_vm.msgRef}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.b_novo),expression:"!b_novo"}]},[_c('b-form',{ref:"form",staticClass:"clearfix",on:{"reset":_vm.reset}},[_vm._t("form"),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":_vm.submit}},[_vm._v("Buscar")]),(_vm.gotData && _vm.totalRows==0)?_c('b-btn',{staticClass:"float-right mr-2",attrs:{"variant":"primary"},on:{"click":function($event){_vm.b_novo=true;}}},[_vm._v("Inserir Novo")]):_vm._e()],2),_c('div',{staticClass:"mt-4"},[_c('table-consulta',{attrs:{"search-on-mount":_vm.searchOnMount,"seleciona":true,"pagina":true,"url-dados":_vm.urlDados,"params-busca":_vm.paramsBusca,"colunas-tabela":_vm.colunasTabela,"msg-ref":_vm.msgRef},on:{"row-clicked":_vm.click},scopedSlots:_vm._u([{key:"camposExtra",fn:function(data){return [_vm._t("camposExtraTabela")]}}],null,true),model:{value:(_vm.dados),callback:function ($$v) {_vm.dados=$$v;},expression:"dados"}})],1)],1),_c('b-collapse',{attrs:{"id":"b_novo"},model:{value:(_vm.b_novo),callback:function ($$v) {_vm.b_novo=$$v;},expression:"b_novo"}},[_c('b-card',{attrs:{"header":"Inserir Novo"}},[_vm._t("formNovo"),_c('b-row',[_c('b-col',{staticClass:"text-right"},[_c('b-link',{staticClass:"text-success pr-2",attrs:{"title":"Salvar"},on:{"click":function($event){return _vm.$emit('inserir-novo')}}},[_c('i',{class:'material-icons align-middle'},[_vm._v("save")]),_vm._v("Salvar")]),_c('b-link',{staticClass:"text-secondary pr-2",attrs:{"title":"Cancelar"},on:{"click":function($event){_vm.$emit('cancelar-novo'); _vm.b_novo=false;}}},[_c('i',{class:'material-icons align-middle'},[_vm._v("cancel")]),_vm._v("Cancelar")])],1)],1)],2)],1)],1)],1)};
    var __vue_staticRenderFns__$b = [];

      /* style */
      var __vue_inject_styles__$b = undefined;
      /* scoped */
      var __vue_scope_id__$b = undefined;
      /* module identifier */
      var __vue_module_identifier__$b = undefined;
      /* functional template */
      var __vue_is_functional_template__$b = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var ModalConsulta = normalizeComponent_1(
        { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
        __vue_inject_styles__$b,
        __vue_script__$b,
        __vue_scope_id__$b,
        __vue_is_functional_template__$b,
        __vue_module_identifier__$b,
        undefined,
        undefined
      );

    //

    var script$c = {
      props: {
        urlAPI: { type: String, default: "http://" + window.location.host + "/api/pdf" },
        titulo: { type: String, default: "" },
        value: { type: Boolean, default: false },
        
        template: { type: String, default: ""},         // nome da blade que gerará o pdf
        dados: { type: Object, default:  function () {} } ,   // dados que preencherão a blade

        tipoArquivo: { type: String, default: "application/pdf" },
        extensao: { type: String, default: "pdf" },
        arquivoNome: { type: String, default: "arquivo" }
      },
      data: function data() {
        return ({
          msgErro: "msgErroPDF",
          mostraInterno: this.mostra,
          linkIFrame: '',
        });
      },
      watch: {
        value: function value() {
          this.mostraInterno = this.value;
          var dados = Object.assign({}, {html: 'true', template: this.template}, this.dados);
          if(this.mostraInterno) {
            this.linkIFrame = this.urlAPI + this.objToQueryString(dados);
          }
        },
        mostraInterno: function mostraInterno() {
          this.$emit('input', this.mostraInterno);
        }
      },
      mounted: function mounted() {
          this.$store.dispatch("flushErro", this.msgErro);
      },
      methods: {
        carregaIframe: function() {
          document.getElementById('loading').className = 'loader loader-default';
        },
        voltar: function voltar() {
          this.linkCompleto  = "";
          this.linkDownload  = "";
          this.pdf           = false;
          this.mostraInterno = false;
        },
        objToQueryString: function objToQueryString(obj) {
          var str = '?' + Object.keys(obj).reduce(function(a, k){
              if(obj[k]) {
                a.push(k + '=' + encodeURIComponent(obj[k]));
              }
              return a;
          }, []).join('&');
          return str;
        },
        geraPDF: function geraPDF() {
          var this$1 = this;

          try {
            var innerHtml = this.html ? this.html : (this.$slots.default ? this.$slots.default[0].elm.innerHTML : '');
            var params = this.template ? Object.assign({}, {template: this.template}, this.dados) : { innerHtml: innerHtml };
      
            document.getElementById("loading").className += " is-active";
            axios.get(this.urlAPI, { params: params, responseType: 'blob' })
              .then(function (response) {
                var respObj = new Blob([response.data], {
                  type: this$1.tipoArquivo
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(respObj);
                link.download = this$1.arquivoNome + "." + this$1.extensao;
                document.body.appendChild(link);
                link.click();
                this$1.carregaIframe();
              })
              .catch(function (error) {
                console.log(error);
                this$1.$store.dispatch("addErro", error);
                this$1.carregaIframe();
      
              });

          } catch(error) {
                this.$store.dispatch("addErro", error);
                this.carregaIframe();

          }
        },
      }
    };

    /* script */
    var __vue_script__$c = script$c;

    /* template */
    var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":_vm.titulo,"size":"lg"},model:{value:(_vm.mostraInterno),callback:function ($$v) {_vm.mostraInterno=$$v;},expression:"mostraInterno"}},[_c('msgs',{attrs:{"msg-ref":_vm.msgErro}}),(_vm.template)?_c('b-embed',{attrs:{"type":"iframe","src":_vm.linkIFrame},on:{"load":_vm.carregaIframe}}):_vm._t("default"),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"variant":"secondary"},on:{"click":_vm.voltar}},[_vm._v("Voltar")]),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.geraPDF}},[_vm._v("Download")])],1)],2)};
    var __vue_staticRenderFns__$c = [];

      /* style */
      var __vue_inject_styles__$c = undefined;
      /* scoped */
      var __vue_scope_id__$c = "data-v-26095c0c";
      /* module identifier */
      var __vue_module_identifier__$c = undefined;
      /* functional template */
      var __vue_is_functional_template__$c = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var ModalPDF = normalizeComponent_1(
        { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
        __vue_inject_styles__$c,
        __vue_script__$c,
        __vue_scope_id__$c,
        __vue_is_functional_template__$c,
        __vue_module_identifier__$c,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$d = {
        props: {
            options: {
                type: Array,
                default: function () { return []; },
            },
            selectSize: {
                type: Number,
                default: 0,
            },
            optionsLabel:{
                type: String,
                default: 'Disponíveis',
            },
            selectedLabel:{
                type: String,
                default: 'Selecionados',
            },
            showLabel:{
                type: Boolean,
                default: true,
            },
            showSearch:{
                type: Boolean,
                default: false,
            },
            value:{
                type: Array,
                default: function () { return []; },
            },
            state: {
                type: Boolean,
                default: null,
            }
        },
        data: function data(){
            return {
                valores_selecionados: [],
                valores_a_adicionar: [],
                valores_a_remover: [],
                picklist_search: '',
            }
        },
        methods: {
            selecionar: function selecionar() { 
                this.valores_selecionados = ( this.valores_selecionados ).concat( this.valores_a_adicionar);
                this.valores_a_adicionar = [];
            },
            remover: function remover() {
                var this$1 = this;
     
                this.valores_selecionados = this.valores_selecionados.filter(function (item) { return this$1.valores_a_remover.indexOf(item) === -1; }
                );
                this.valores_a_remover = [];
            },         
        },
        computed: {
            opcoes_selecionadas: function opcoes_selecionadas() {
                var this$1 = this;

                return this.options.filter(function (item) { return this$1.valores_selecionados.indexOf(item.value) !== -1; }
                );
            },
            opcoes_disponiveis: function opcoes_disponiveis() {
               var this$1 = this;

               return this.options.filter(function (item) { return this$1.valores_selecionados.indexOf(item.value) === -1 && item.text.includes(this$1.picklist_search); })
            }
        },
        watch: {
            valores_selecionados: function valores_selecionados(value) {
                this.$emit('input',value);
            },
            value: function value(value$1){
                this.valores_selecionados = value$1;
            }
        }
    };

    /* script */
    var __vue_script__$d = script$d;

    /* template */
    var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLabel)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-sm"},[_vm._v(_vm._s(_vm.optionsLabel))]),_c('div',{staticClass:"d-none d-sm-block col-sm-3 col-lg-2"},[_vm._v(" ")]),_c('div',{staticClass:"d-none d-sm-block col-sm"},[_vm._v(_vm._s(_vm.selectedLabel))])]):_vm._e(),(_vm.showSearch)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-sm"},[_c('b-input-group',{attrs:{"size":"sm"}},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})]),_c('b-form-input',{model:{value:(_vm.picklist_search),callback:function ($$v) {_vm.picklist_search=$$v;},expression:"picklist_search"}})],1)],1),_c('div',{staticClass:"d-none d-sm-block col-sm-3 col-lg-2"},[_vm._v(" ")]),_c('div',{staticClass:"d-none d-sm-block col-sm"},[_vm._v(" ")])]):_vm._e(),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-sm"},[_c('b-form-select',{staticClass:"h-100",attrs:{"options":_vm.opcoes_disponiveis,"multiple":"","select-size":_vm.selectSize,"state":_vm.state},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selecionar($event)}},model:{value:(_vm.valores_a_adicionar),callback:function ($$v) {_vm.valores_a_adicionar=$$v;},expression:"valores_a_adicionar"}})],1),_c('div',{staticClass:"col-sm-3 col-lg-2 p-2 align-items-center"},[_c('b-button',{attrs:{"variant":"primary","size":"sm","block":""},on:{"click":_vm.selecionar}},[_vm._v("Adicionar "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})]),_c('b-button',{attrs:{"variant":"primary","size":"sm","block":""},on:{"click":_vm.remover}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Remover")])],1),_c('div',{staticClass:"col-sm"},[(_vm.showLabel)?_c('div',{staticClass:"d-block d-sm-none"},[_vm._v(_vm._s(_vm.selectedLabel))]):_vm._e(),_c('b-form-select',{staticClass:"h-100",attrs:{"options":_vm.opcoes_selecionadas,"multiple":"","select-size":_vm.selectSize,"state":_vm.state},model:{value:(_vm.valores_a_remover),callback:function ($$v) {_vm.valores_a_remover=$$v;},expression:"valores_a_remover"}})],1)])])};
    var __vue_staticRenderFns__$d = [];

      /* style */
      var __vue_inject_styles__$d = undefined;
      /* scoped */
      var __vue_scope_id__$d = undefined;
      /* module identifier */
      var __vue_module_identifier__$d = undefined;
      /* functional template */
      var __vue_is_functional_template__$d = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var PickList = normalizeComponent_1(
        { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
        __vue_inject_styles__$d,
        __vue_script__$d,
        __vue_scope_id__$d,
        __vue_is_functional_template__$d,
        __vue_module_identifier__$d,
        undefined,
        undefined
      );

    //
    var script$e = {
        components: {
            circuloProgresso: circuloprogresso
        },

        props: {
            itens: {
                type: Object,
                default: function () {}
            },
            circulo: {
                default: function () {}
            },
            //classe do ícone apresentado para seções não preenchidas
            iconeVazio: {
                type: String,
                default: 'fa-square-o text-secondary',
            },
            //classe do ícone apresentado para seções preenchidas corretamente
            iconeValido: {
                type: String,
                default: 'fa-check text-success',
            },
            //classe do ícone apresentado para seções não preenchidas
            iconeInvalido: {
                type: String,
                default: 'fa-times text-danger',
            },
            //classes modificadores dos icones (permitem distinguir os ícones de itens e subitens)
            iconeItem: {
                type: String,
                default: 'fa-lg',
            },
            iconeSubitem: {
                type: String,
                default: '',
            },
            //determina o clicar na barra de progresso deve deslizar para a referida seção
            clicavel: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            /**
             * Calcula a porcentagem de itens que foram validados dentre os requeridos
             */
            porcentagem_validada: function porcentagem_validada() {
                var items = _(this.itens).filter(function (item) { return item.incluso && item.requerido; });
                var conta = items.countBy('validado').value();
                var resultado = conta.true ? (conta.true / items.size() * 100) : 0;
                //this.$emit('atualizarProgresso', Math.round(resultado));                          
                this.atualizarProgresso(this, Math.round(resultado));
                return resultado;
            },

            /**
             * Retorna somente as itens que devem ser apresentados na barra de progresso
             */
            itens_inclusos: function itens_inclusos() {
                return _(this.itens).pickBy(function (o) { return o.incluso && o.requerido; }).mapValues(function (obj) {
                    var o = Object.assign({}, obj);
                    if(o.sub) { o.sub = _.pickBy(o.sub, function (sub) { return sub.incluso; }); }
                    return o;
                }).value();
            }
        },

        methods: {
            atualizarProgresso: _.debounce(function (comp, valor) {
                comp.$emit('atualizarProgresso', valor);
            }, 200)
        },

        created: function created() {
            var this$1 = this;

            var loop = function ( i ) {
                //se o item possui subitens, o estado da validação dos subitens determina o estado da validação do item pai
                if(this$1.itens[i].sub)
                    { Object.defineProperty(this$1.itens[i], 'validado', {
                        get: function () { return _.find( this$1.itens[i].sub, function (secao) { return secao.incluso && secao.requerido && (secao.validado === false); })
                                    ? false
                                    : _.find( this$1.itens[i].sub, function (secao) { return secao.incluso && secao.requerido && (secao.validado === null); }) ? null : true; }
                    }); }
            };

            for(var i in this$1.itens) loop( i );
        },
    };

    /* script */
    var __vue_script__$e = script$e;

    /* template */
    var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.circulo !== false)?_c('circulo-progresso',_vm._b({attrs:{"percentage":_vm.porcentagem_validada}},'circulo-progresso',_vm.circulo,false)):_vm._e(),_vm._l((_vm.itens_inclusos),function(item,id){return _c('div',{key:id,staticClass:"list-group list-group-flush lista-progresso"},[_c('a',{staticClass:"list-group-item list-group-item-action",attrs:{"href":'#'+id},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click-secao', id)}}},[[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2 col-xs-2 align-self-center p-0 text-center"},[_c('i',{staticClass:"fa",class:(item.validado === null ? _vm.iconeVazio : item.validado ? _vm.iconeValido : _vm.iconeInvalido) + ' ' + _vm.iconeItem,attrs:{"aria-hidden":"true"}})]),_c('div',{staticClass:"col-10 col-xs-10 px-1 align-self-center"},[_c('div',{staticClass:"item-title text-muted"},[_vm._v(_vm._s(item.title))])])]),(item.sub)?_vm._l((item.sub),function(subitem,id_subitem){return _c('div',{key:id_subitem,staticClass:"row"},[_c('div',{staticClass:"col-2 col-xs-2 align-self-center p-0 text-center"},[_c('i',{staticClass:"fa",class:(subitem.validado === null ? _vm.iconeVazio : subitem.validado ? _vm.iconeValido : _vm.iconeInvalido)  + ' ' + _vm.iconeSubitem,attrs:{"aria-hidden":"true"}})]),_c('div',{staticClass:"col-10 col-xs-10 px-1 align-self-center"},[_c('div',{staticClass:"item-subtitle"},[_vm._v(_vm._s(subitem.title))])])])}):_vm._e()]],2)])}),_vm._t("default")],2)};
    var __vue_staticRenderFns__$e = [];

      /* style */
      var __vue_inject_styles__$e = function (inject) {
        if (!inject) { return }
        inject("data-v-af104cb8_0", { source: ".lista-progresso{margin:0 -1.2rem}.lista-progresso .list-group-item{border:0}.lista-progresso .item-title{font-size:.75rem;text-transform:uppercase}.lista-progresso .item-subtitle{font-size:.85rem}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__$e = undefined;
      /* module identifier */
      var __vue_module_identifier__$e = undefined;
      /* functional template */
      var __vue_is_functional_template__$e = false;
      /* style inject SSR */
      

      
      var progresso = normalizeComponent_1(
        { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
        __vue_inject_styles__$e,
        __vue_script__$e,
        __vue_scope_id__$e,
        __vue_is_functional_template__$e,
        __vue_module_identifier__$e,
        browser,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$f = {

        props: {
            title: String,
            validado: Boolean,
            id: {
                type: String,
                default: 'secao'+Number.parseInt(Math.random()*100000000)
            },
            aberto: {
                type: Boolean,
                default: false,
            },
            visualizacao: {
                type: Boolean,
                default: false,
            },
            salvo: {
                type: Boolean,
                default: false,
            },
            incluso: {
                type: Boolean,
                default: false,
            },
            requerido: {
                type: Boolean,
                default: false,
            },
            botaoOcultar:  { 
                type: Boolean, 
                default: true 
            },
            sub: Object,
            beforeOpen: false,
        },

        data: function data() {
            return {
                //controla a abertura do modal
                editando: false,
                //indica que o componente interno já foi criado
                slot_componente_criado: false,
                //parâmetros repassados para o componente interno antes que ele seja criado
                params: null,
                alerta: {
                    value: false,
                    mensagens: [],
                    dismissible: true,
                    variant: 'warning',
                }
            }
        },

        methods: {
            /**
             * Lança um evento solicitando que atributo de um secao/subseção sejam atalizados
             * 
             * @param {Object} obj lista de atributos que devem ser atualizados para a secao.
             * @param {string} subsecao Se deve atualizar uma subseção, informe a chave
             */
            atualizar: function atualizar(obj, subsecao) {
                this.$emit('atualizar', this.objAtualizar(obj, subsecao));
            },
            /**
             * Cria um objeto com informações para atualização de uma seção/subseção
             * 
             * @param {Object} obj Que pode ser uma lista de atributos que devem ser atualizados para a secao. Ou um objeto criado por outra chamada a objAtualizar()
             * @param {string} subsecao Se o objeto deve fazer referência a uma subseção, informe a chave
             */
            objAtualizar: function objAtualizar(obj, subsecao) {
                var o = obj;
                //Se vier um objeto já composto pelo nome da secao
                if(o.hasOwnProperty('secao')) {
                    if(this.sub && this.sub.hasOwnProperty(o.secao))
                        { o.secao = this.id+'.'+o.secao; }
                } 
                //se vier apenas a lista de atributos, compõe o objeto
                else {
                    o =  { secao: this.id+(subsecao ? '.'+subsecao : ''), atributos: Object.assign({}, obj) };
                }
                return o;
            },
            /**
             * Fecha a seção e força que o componente interno seja recriado na próxima vex que abrir
             */
            recriar: function recriar(mensagens) {
                this.slot_componente_criado = false;
                this.$emit('atualizar', this.objAtualizar({ aberto: false }));
                //apresenta acima da seção a mensagem de erro que foi apresentada
                this.alerta.mensagens = this.$helper.getMsg(mensagens);
                this.alerta.value = true;
            }
        },

        watch: {
            aberto: function aberto(valor) {
                var this$1 = this;

                //se está sendo aberto
                if(valor) {
                    //se o componente interno já foi criado, simplesmente abre o modal para exibição
                    if(this.slot_componente_criado) {
                        this.editando = true;
                    }
                    //se o componente interno será criado agora
                    else {
                        var criaSlotComponente = function () {
                            this$1.slot_componente_criado = true;
                            //O modal só é aberto para exibir o componente no próximo ciclo onde ele já terá sido criado
                            this$1.$nextTick(function () {
                                this$1.editando = valor;
                            });
                        };

                        //se forneceu uma função que deve ser executada para fornecer parâmetros para o componente antes da criação
                        if(typeof this.beforeOpen === 'function') {
                            var retorno = this.beforeOpen();
                            if(retorno instanceof Promise) {
                                retorno.then(function (response) {
                                    this$1.params = response.data;
                                    criaSlotComponente();
                                });
                            } else {
                                this.params = retorno;
                                criaSlotComponente();
                            }
                        } else {
                            criaSlotComponente();
                        }
                    }
                    //oculta mensagens de alerta da seção quando ela voltar a ser aberta
                    this.alerta.value = false;
                    this.alerta.mensagens = [];
                } 
                //se está sendo fechado
                else {
                    this.editando = false;
                }
            }
        }
    };

    /* script */
    var __vue_script__$f = script$f;

    /* template */
    var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.id}},[_c('h2',{staticClass:"title"},[(_vm.validado !== null)?_c('i',{class:'fa fa-'+(_vm.validado ? 'check text-success' : 'times text-danger'),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('alert',_vm._b({},'alert',_vm.alerta,false)),_c('div',{class:{ 'card simples': !_vm.sub }},[_c('div',{class:_vm.sub ? 'subitens' : 'card-body'},[_c('b-collapse',{attrs:{"id":'collapse'+_vm.id},model:{value:(_vm.editando),callback:function ($$v) {_vm.editando=$$v;},expression:"editando"}},[(_vm.slot_componente_criado)?_c('div',[_vm._t("default",null,null,{ title: _vm.title, validado: _vm.validado, id: _vm.id, aberto: _vm.aberto, visualizacao: _vm.visualizacao, salvo: _vm.salvo, sub: _vm.sub, params: _vm.params, atualizar: _vm.atualizar, recriar: _vm.recriar })],2):_vm._e()]),(!_vm.aberto)?_vm._t("botoes-fechado",[_c('div',{staticClass:"text-right"},[(_vm.visualizacao)?[(_vm.salvo)?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.atualizar({ aberto: true })}}},[_c('i',{staticClass:"fa fa-angle-double-down fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" visualizar")]):_c('div',{staticClass:"text-center text-muted"},[_vm._v("Ainda não foi informado.")])]:(_vm.salvo)?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.atualizar({ aberto: true })}}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" editar")]):_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.atualizar({ aberto: true })}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" adicionar")])],2)]):(_vm.visualizacao && _vm.botaoOcultar)?_c('div',{staticClass:"text-right"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.atualizar({ aberto: false })}}},[_c('i',{staticClass:"fa fa-angle-double-up fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" ocultar")])],1):_vm._e()],2)])],1)};
    var __vue_staticRenderFns__$f = [];

      /* style */
      var __vue_inject_styles__$f = function (inject) {
        if (!inject) { return }
        inject("data-v-833a0bda_0", { source: ".subitens h2{font-size:1.4rem;margin:2.1rem 0 1.05rem}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__$f = undefined;
      /* module identifier */
      var __vue_module_identifier__$f = undefined;
      /* functional template */
      var __vue_is_functional_template__$f = false;
      /* style inject SSR */
      

      
      var secaoEditavel = normalizeComponent_1(
        { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
        __vue_inject_styles__$f,
        __vue_script__$f,
        __vue_scope_id__$f,
        __vue_is_functional_template__$f,
        __vue_module_identifier__$f,
        browser,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$g = {
        props: {
            //Se deve carregar do servidor somente a página atual (Default: false = carrega todos os dados)
            backendPagination: { type: Boolean, default: false },
            bordered:  { type: Boolean, default: true },
            busy:  { type: Boolean, default: false },
            caption: String,
            checkable: { type: Boolean, default: false },
            checked: { type: Array, default: function (){ return []; } },
            emptyFilteredText: { type: String, default: "Nenhum registro atende a pesquisa" },
            emptyFilteredHtml: { type: String, default: "" },
            emptyText: { type: String, default: "Nenhum registro encontrado" },
            emptyHtml: { type: String, default: "" },
            fields: Array,
            /** @TODO por enquanto o filter só funciona para paginação front-end (backendPagination == false) */
            filter: null,
            filterFunction: null,
            //Se deve carregar dados do servidor mesmo que já tenha sido setado dados iniciais 
            forceGetFromBackend: { type: Boolean, default: false },
            hover:  { type: Boolean, default: true },
            msgRef: String,
            pagina: { type: Boolean, default: true },
            paramsBusca: { default: function () { return {} } },
            perPage: { type: Number, default: 10 },
            responsive: false,
            searchOnMount: { type: Boolean, default: false },
            selected: Array,
            showEmpty: { type: Boolean, default: true },
            //se deve mostrar cabeçalho quando a tabela não tiver nenhum registro
            showEmptyHeader: { type: Boolean, default: false },
            tableClass: { type: String, default: "" },
            urlDados: String,
            //se deve usar parâmetro da url para determinar a paginação e ordenação inicial
            useRouteQuery: false,
            value: Array,
        },
        data: function data() {
           return {
               currentPage: 1,
               totalRows: 0,
               lastPage: 0,
               sortBy: '',
               sortDesc: '',
               dados: [],
               checados: [],
           }   
        },
        watch: {
            value: function value() {
                this.getData();
            },
            dados: function dados(valor){
                this.checados = [];
                this.$emit("update:checked", this.checados);
            },
            checked: function checked(valor){
                this.checados = [].concat( valor );
            },
        },
        computed: {
            /**
             * Adiciona campos default aos campos informados pelo usuário
             */
            table_fields: function table_fields() {
                var fields = [].concat( this.fields );
                //se a tabela é checable mas não especificou uma coluna 'check', ela será adicionada no final
                if(this.checkable && this.fields.filter(function (field) { return field.key === 'check'; }).length === 0) {
                    fields.unshift({ key: 'check', label: 'Selecionar' });
                }
                return fields;
            },
            table_class: function table_class() {
                // Se a tabela tem o efeito hover, presume que ela é clicável
                if(this.hover && !this.tableClass.includes("table-clickable"))
                    { return this.tableClass + " table-clickable"; }
                else
                    { return this.tableClass; }
            }
        },
        methods: {
            reset: function reset() {
               this.currentPage = 1;
               this.totalRows   = 0;
               this.dados       = [];
            },
            show: function show() {
                if(this.searchOnMount) {
                    this.getData(); 
                }
            },
            esconderTodos: function esconderTodos() {
                this.dados.forEach(function (element) { if(element._showDetails) { element._showDetails = false; } });
            },
            getData: function getData() {
                var this$1 = this;

                if(this.value && !this.forceGetFromBackend && !this.backendPagination) {
                    this.dados     = this.value;
                    this.totalRows = this.value.length;
                } else {
                    var params = this.paramsBusca;
                    if(this.backendPagination) {
                        params.page = this.currentPage;
                        params.sortBy = this.sortBy;
                        params.sortDesc = this.sortDesc ? 1 : 0;
                        params.perPage = this.perPage;
                    }

                    if(this.urlDados) {
                        this.$api.getFonteDados(this.urlDados, this.paramsBusca)
                        .then(function (response) {
                            if(response.data) {
                                //se o resulta contém informações de paginação
                                if(Array.isArray(response.data.data)) {
                                    this$1.dados = response.data.data;
                                    this$1.totalRows = response.data.total;
                                    this$1.lastPage = response.data.last_page;
                                } 
                                //se o resultado é apenas uma lista
                                else if (Array.isArray(response.data)) {
                                    this$1.dados = response.data;
                                    this$1.totalRows = response.data.length;
                                    this$1.lastPage = Math.ceil(this$1.totalRows / this$1.perPage);
                                }
                                this$1.$emit('success', this$1.dados);
                            }
                        })
                        .catch(function (error) {
                            this$1.printMsg(error,{scroll: false});
                            this$1.reset();
                            this$1.$emit('error');
                        });
                    }
                }
            },

            /**
             * Adiciona um item à lista de selecionados
             * 
             * @param {int} item Item que está sendo selecionado ou removido da seleção
             * @param {int} checked se deve adicionar ou remover o item. Se não for informado, inverte o estado da seleção.
             */
            check: function check(item, checked) {
                if ( checked === void 0 ) checked = null;

                var posicao_atual = this.checados.indexOf(item);
                if(checked === null) { checked = (posicao_atual === -1); }
                //verifica se deve adicionar ou remover
                if(checked) {
                    if(posicao_atual===-1)//se ainda não estava, inclui
                        { this.checados.push(item); }
                    item._rowVariant="primary";
                } else {
                    if(posicao_atual!==-1)//se já estava, remove
                        { this.checados.splice(posicao_atual, 1); }
                    item._rowVariant="";    
                }
                this.$emit("update:checked", this.checados);
            },

            /**
             * Acionado quando o a tabela recebe um filtro
             */
            onFiltered: function onFiltered(filteredItems) {
                if(this.filter) {
                    this.currentPage = 1;
                    this.totalRows = filteredItems.length;
                    this.$emit('filtered', filteredItems);
                }
            },

            /**
             * Muda página
             */
            mudaPagina: function mudaPagina(pagina) {
                this.currentPage = pagina;
                //se a paginação deve ser feita no backend
                if(this.backendPagination) {
                    this.getData();
                }
            },
            mudaOrdenacao: function mudaOrdenacao(ordenacao) {
                this.sortBy = ordenacao.sortBy;
                this.sortDesc = ordenacao.sortDesc;
                if(this.backendPagination) {
                    this.currentPage = 1;
                    this.getData();
                }
            }
        },
        mounted: function mounted() {
            if(this.useRouteQuery && this.$route) {
                var q = this.$route.query;
                if(q.hasOwnProperty('page')) { this.currentPage = parseInt(q.page); }
                if(q.hasOwnProperty('sortBy')) { this.sortBy = q.sortBy; }
                if(q.hasOwnProperty('sortDesc')) { this.sortDesc = (q.sortDesc == '1'); }
                if(q.hasOwnProperty('perPage')) { this.perPage = parseInt(q.perPage); }
            }
            this.show();
        }
    };

    /* script */
    var __vue_script__$g = script$g;

    /* template */
    var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"envelope-tabela"},[_c('b-table',{staticClass:"tabelaConsulta",class:_vm.table_class,attrs:{"no-provider-paging":"","small":"","striped":"","bordered":_vm.bordered,"busy":_vm.busy,"caption":_vm.caption,"current-page":_vm.currentPage,"empty-filtered-text":_vm.emptyFilteredText,"empty-filtered-html":_vm.emptyFilteredHtml,"empty-text":_vm.emptyText,"empty-html":_vm.emptyHtml,"fields":_vm.table_fields,"filter":_vm.filter,"filter-function":_vm.filterFunction,"hover":_vm.hover,"items":_vm.dados,"per-page":_vm.backendPagination ? 0: _vm.perPage,"responsive":_vm.responsive,"show-empty":_vm.showEmpty,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"no-local-sorting":_vm.backendPagination,"thead-class":_vm.showEmptyHeader || _vm.dados.length  ? '' : 'd-none'},on:{"filtered":_vm.onFiltered,"row-clicked":function($event){return _vm.$emit('row-clicked', $event)},"sort-changed":_vm.mudaOrdenacao},scopedSlots:_vm._u([{key:"check",fn:function(data){return [_vm._t("check",[(_vm.checkable)?[_c('b-checkbox',{attrs:{"checked":_vm.checados.includes(data.item)},on:{"change":function($event){return _vm.check(data.item, $event)}},nativeOn:{"click":function($event){$event.stopPropagation();}}})]:_vm._e()],null,{data: data, check: _vm.check, checked: _vm.checados.includes(data.item)})]}},{key:"campoExtra1",fn:function(data){return [_vm._t("campoExtra1",null,null,{data: data})]}},{key:"campoExtra2",fn:function(data){return [_vm._t("campoExtra2",null,null,{data: data})]}}],null,true)}),_c('b-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagina && _vm.totalRows > _vm.perPage),expression:"pagina && totalRows > perPage"}],staticClass:"mb-0 mt-3",attrs:{"align":"right","total-rows":_vm.totalRows,"per-page":_vm.perPage,"value":_vm.currentPage},on:{"change":_vm.mudaPagina}})],1)};
    var __vue_staticRenderFns__$g = [];

      /* style */
      var __vue_inject_styles__$g = function (inject) {
        if (!inject) { return }
        inject("data-v-29dcee2c_0", { source: ".tabelaConsulta>.table,table.tabelaConsulta{margin-bottom:0}.tabelaConsulta thead th{vertical-align:middle;text-align:center;font-weight:700}.envelope-tabela:not(:last-child){margin-bottom:1rem}", map: undefined, media: undefined });

      };
      /* scoped */
      var __vue_scope_id__$g = undefined;
      /* module identifier */
      var __vue_module_identifier__$g = undefined;
      /* functional template */
      var __vue_is_functional_template__$g = false;
      /* style inject SSR */
      

      
      var TableConsulta = normalizeComponent_1(
        { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
        __vue_inject_styles__$g,
        __vue_script__$g,
        __vue_scope_id__$g,
        __vue_is_functional_template__$g,
        __vue_module_identifier__$g,
        browser,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    var script$h = {
        props: {
            items: {
                type: Array,
                default: function () { return []; },
            },
            showLoadButton: {
                type: Boolean,
                default: false,
            },
            mensagemVazio: {
                type: String,
                default: 'Nenhum registro foi encontrado.'
            }
        },
    };

    /* script */
    var __vue_script__$h = script$h;

    /* template */
    var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items.length > 0)?_c('ul',{staticClass:"timeline"},[_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"timeline-item"},[_c('div',{class:'timeline-badge bg-'+item.icon_status},[_c('i',{class:item.icon_class})]),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[(item.title)?_c('h6',{staticClass:"timeline-title",domProps:{"innerHTML":_vm._s(item.title)}}):_vm._e(),_c('div',{staticClass:"timeline-panel-controls"},[_c('div',{staticClass:"controls small text-muted",domProps:{"innerHTML":_vm._s(item.controls)}}),_c('div',{staticClass:"timestamp"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("dateToString")(item.created,'DD/MM/YYYY HH:mm')))])])])]),(item.body)?_c('div',{staticClass:"timeline-body small",domProps:{"innerHTML":_vm._s(item.body)}}):_vm._e(),_vm._t("detalhe",null,null,item)],2)])}),(_vm.showLoadButton)?_c('li',{staticClass:"timeline-item"},[_c('div',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('click-load')}}},[_c('i',{staticClass:"fa fa-angle-double-down fa-lg mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("Carregar mais")])],1)]):_vm._e()],2):_c('div',[_c('alert',{attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.mensagemVazio))])],1)])};
    var __vue_staticRenderFns__$h = [];

      /* style */
      var __vue_inject_styles__$h = undefined;
      /* scoped */
      var __vue_scope_id__$h = undefined;
      /* module identifier */
      var __vue_module_identifier__$h = undefined;
      /* functional template */
      var __vue_is_functional_template__$h = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var timeline = normalizeComponent_1(
        { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
        __vue_inject_styles__$h,
        __vue_script__$h,
        __vue_scope_id__$h,
        __vue_is_functional_template__$h,
        __vue_module_identifier__$h,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$i = {
      name: "Topo",
      props: {
        logoURL: {
          type: String,
          default: ""
        },
        sigla: {
          type: String,
          default: ""
        },
        itensMenu: {
          type: Array,
          default: function () { return []; }
        },
        usuario: {
          type: Object,
          default: function () {}
        },
        logoutCallback: {
          type: Function,
          default: function () {}
        },
        homeLink: {
          type: String,
          default: "login"
        }
      }
    };

    /* script */
    var __vue_script__$i = script$i;

    /* template */
    var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar topo navbar-expand-lg sticky-top navbar-light bg-light border-bottom p-0"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"navbar-brand mr-0 mr-sm-3 d-flex",attrs:{"to":_vm.homeLink}},[_c('span',{staticClass:"logo align-self-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logoURL,"title":'Prefeitura de Belo Horizonte -'+_vm.sigla,"alt":"Logo Prefeitura de Belo Horizonte"}})]),_c('span',{staticClass:"divisoria align-self-center mx-2"},[_vm._v("\n        |\n      ")]),_c('span',{staticClass:"sigla align-self-center"},[_vm._v("\n        "+_vm._s(_vm.sigla)+"\n      ")])]),(_vm.itensMenu.length)?_c('button',{staticClass:"navbar-toggler m-2 ml-auto",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})]):_vm._e(),(_vm.itensMenu.length)?_c('menu-horizontal',{attrs:{"itens":_vm.itensMenu,"usuario":_vm.usuario,"logout-callback":_vm.logoutCallback}}):_vm._e()],1)])};
    var __vue_staticRenderFns__$i = [];

      /* style */
      var __vue_inject_styles__$i = undefined;
      /* scoped */
      var __vue_scope_id__$i = undefined;
      /* module identifier */
      var __vue_module_identifier__$i = undefined;
      /* functional template */
      var __vue_is_functional_template__$i = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var topo = normalizeComponent_1(
        { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
        __vue_inject_styles__$i,
        __vue_script__$i,
        __vue_scope_id__$i,
        __vue_is_functional_template__$i,
        __vue_module_identifier__$i,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$j = {
      name: "MenuHorizontal",
      props: {
        itens: {
          type: Array,
          default: function () { return []; }
        },
        logoutCallback: {
          type: Function,
          default: function () {}
        },
        usuario: {
          type: Object,
          default: null
        }
      },
      methods: {
        logout: function logout() {
          this.logoutCallback();
        }
      }
    };

    /* script */
    var __vue_script__$j = script$j;

    /* template */
    var __vue_render__$j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse h-100",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav ml-auto h-100"},[_vm._l((_vm.itens),function(item,indice){return _c('li',{key:item.titulo,staticClass:"nav-item my-auto",class:{dropdown: item.subitens}},[(!item.subitens)?[(item.button)?_c('router-link',{staticClass:"btn btn-primary m-2",attrs:{"to":item.to}},[_vm._v("\n          "+_vm._s(item.titulo)+"\n        ")]):_c('router-link',{staticClass:"nav-link",attrs:{"to":item.to}},[_vm._v("\n          "+_vm._s(item.titulo)+"\n        ")])]:[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"id":'navbarDrop'+item.indice,"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n          "+_vm._s(item.titulo)+"\n        ")]),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":'navbarDrop'+item.indice}},_vm._l((item.subitens),function(subitem,ind_sub){return _c('router-link',{key:indice+'/'+ind_sub,staticClass:"dropdown-item",attrs:{"to":subitem.to}},[_vm._v("\n            "+_vm._s(subitem.titulo)+"\n          ")])}),1)]],2)}),(_vm.usuario !== null)?_c('li',{staticClass:"nav-item my-auto"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("\n        sair\n        "),_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}})])]):_vm._e()],2)])};
    var __vue_staticRenderFns__$j = [];

      /* style */
      var __vue_inject_styles__$j = undefined;
      /* scoped */
      var __vue_scope_id__$j = undefined;
      /* module identifier */
      var __vue_module_identifier__$j = undefined;
      /* functional template */
      var __vue_is_functional_template__$j = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var menuHorizontal = normalizeComponent_1(
        { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
        __vue_inject_styles__$j,
        __vue_script__$j,
        __vue_scope_id__$j,
        __vue_is_functional_template__$j,
        __vue_module_identifier__$j,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$k = {
      name: "Rodape",
      props: {
        logoURL: { type: String, default: "" },
        versao: { type: String, default: "" },
      }
    };

    /* script */
    var __vue_script__$k = script$k;

    /* template */
    var __vue_render__$k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer bg-light"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-lg-2 d-none d-sm-block pl-0 text-center align-self-center"},[_vm._v("\n        "+_vm._s(_vm.versao)+"\n      ")]),_c('div',{staticClass:"col-sm text-center align-self-center"},[_vm._v("\n        © Prefeitura Municipal de Belo Horizonte\n      ")]),_c('div',{staticClass:"col-md-3 col-lg-2 d-none d-md-block pl-0 text-center align-self-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.logoURL,"alt":"Prefeitura de Belo Horizonte"}})])])])])};
    var __vue_staticRenderFns__$k = [];

      /* style */
      var __vue_inject_styles__$k = undefined;
      /* scoped */
      var __vue_scope_id__$k = undefined;
      /* module identifier */
      var __vue_module_identifier__$k = undefined;
      /* functional template */
      var __vue_is_functional_template__$k = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var rodape = normalizeComponent_1(
        { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
        __vue_inject_styles__$k,
        __vue_script__$k,
        __vue_scope_id__$k,
        __vue_is_functional_template__$k,
        __vue_module_identifier__$k,
        undefined,
        undefined
      );

    moment.locale(constantes.LOCALE);

    var dateToString = function (dataObj, format) {
        if ( format === void 0 ) format = 'L';

        if(!dataObj) { return ''; }
        if(typeof dataObj === 'string') {
            dataObj = moment(dataObj);
        } else if(typeof dataObj === 'object' && dataObj.date) {
            dataObj = moment(dataObj.date);
        }
        if (!dataObj.isValid()) { return ''; }
        return dataObj.format(format);
    };

    var formataCpf = function (cpf) {
        if(cpf) {
            var n = cpf.replace(/\D/g, '');
            return (n.length == 11)
                ? ("" + (n[0]) + (n[1]) + (n[2]) + "." + (n[3]) + (n[4]) + (n[5]) + "." + (n[6]) + (n[7]) + (n[8]) + "-" + (n[9]) + (n[10]))
                : cpf
        }
    };

    var telefone = function (str_tel) {
        var tel = String(str_tel).replace(/\D/g,"");
        if(tel.length === 12 && tel[0] == 0) { tel = tel.substr(1); }
        var len = tel.length;
        return len < 10 || len > 11
            ? tel
            : '('+tel.substr(0, 2)+')'+tel.substr(2, len-6)+'-'+tel.substr(len-4);
    };

    /**
     * Formata um número como cpf ou cnpj dependendo da quantidade de dígitos.
     * Não verifica se o número está correto, formata apenas se tiverem a quantidade exata de dígitos de cpf ou cnpf.
    */
    var cpfCnpj = function (num) {
        if(num) {
            var n = num.replace(/\D/g, '');
            return (n.length == 11) //cpf
                ? ("" + (n[0]) + (n[1]) + (n[2]) + "." + (n[3]) + (n[4]) + (n[5]) + "." + (n[6]) + (n[7]) + (n[8]) + "-" + (n[9]) + (n[10]))
                : (n.length == 14) //cnpj
                    ? ("" + (n[0]) + (n[1]) + "." + (n[2]) + (n[3]) + (n[4]) + "." + (n[5]) + (n[6]) + (n[7]) + "/" + (n[8]) + (n[9]) + (n[10]) + (n[11]) + "-" + (n[12]) + (n[13]))
                    : num //tamanho inválido
        }
    };

    /**
     * Formata um número como cnpj
     */
    var cep = function (num) {
        if(num) {
            var n = num.replace(/\D/g, '');
            return ("" + (n[0]) + (n[1]) + "." + (n[2]) + (n[3]) + (n[4]) + "-" + (n[5]) + (n[6]) + (n[7]))
        } else
            { return ''; }
    };

    /**
     * Restringe a quantidade de casas decimais de um número
     */
    var decimal$1 = function (valor, precisao) {
        if ( precisao === void 0 ) precisao = 2;

        if ((valor || valor === 0) && !isNaN(valor)) {
            return Number.parseFloat(valor).toFixed(precisao).replace('.', ',');
        }
        else {
            return '';
        }
    };

    /**
     * Recebe um objeto endereço e retorna como string
     */
    var endereco = function (e) {
        return (e.tipo_logradouro ? e.tipo_logradouro + ' ' : '')
                + e.logradouro
                + (e.numero ?        ', '+e.numero : '')
                + (e.complemento ?   ', '+e.complemento : '')
                + (e.bairro ?        ', '+e.bairro : '');
    };

    /**
     * Converte os valores sim/não nas descrições correspondentes
     */
    var simNao = function (v) { return constantes.SIM_NAO[v] || ''; };

    /**
     * Apresenta a descrição textual da data com relação ao momento atual
     */
    var dateFromNow = function (v) {
        var d = moment(v);
        return d.isValid() ? d.fromNow() : ''
    };

    /**
     * Retorna o texto transformando espaços e quebras de linha em entidades html
     */
    var textAsHTML = function (text) {
        var formated = (text + '')
            .replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2') // quebra de linha
            .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') // tab
            .replace(/\s{2}/g, ' &nbsp;'); // espaços concatenados
        return formated;
    };

    /*
     * Insere os separadores de milhar em uma string decimal
     */
    var separadorMilhar = function (valor, separadorDecimal, separadorMilhar) {
        if ( separadorDecimal === void 0 ) separadorDecimal = ',';
        if ( separadorMilhar === void 0 ) separadorMilhar = '.';

        if (valor) {
            var arrayValor = valor.split(separadorDecimal);
            return arrayValor[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadorMilhar) + separadorDecimal + (arrayValor[1] ? arrayValor[1] : '00');
        }
        else {
            return '';
        }
    };

    var filters = { dateToString: dateToString, formataCpf: formataCpf, telefone: telefone, cep: cep, cpfCnpj: cpfCnpj, dateFromNow: dateFromNow, decimal: decimal$1, endereco: endereco, separadorMilhar: separadorMilhar, simNao: simNao, textAsHTML: textAsHTML };

    var messages = {"en.auth":{"blocked":"User blocked. Contact the Admin to unlock.","expired":"Enter your credentials to continue using the system.","failed":"These credentials do not match our records.","logout_success":"Successful logout.","throttle":"Too many login attempts. Please try again in :seconds seconds."},"en.pagination":{"next":"Next &raquo;","previous":"&laquo; Previous"},"en.passwords":{"password":"Passwords must be at least six characters and match the confirmation.","reset":"Your password has been reset!","sent":"We have e-mailed your password reset link!","token":"This password reset token is invalid.","user":"We can't find a user with that e-mail address."},"en.validation":{"accepted":"The :attribute must be accepted.","active_url":"The :attribute is not a valid URL.","after":"The :attribute must be a date after :date.","after_or_equal":"The :attribute must be a date after or equal to :date.","alpha":"The :attribute may only contain letters.","alpha_dash":"The :attribute may only contain letters, numbers, and dashes.","alpha_num":"The :attribute may only contain letters and numbers.","array":"The :attribute must be an array.","attributes":[],"before":"The :attribute must be a date before :date.","before_or_equal":"The :attribute must be a date before or equal to :date.","between":{"array":"The :attribute must have between :min and :max items.","file":"The :attribute must be between :min and :max kilobytes.","numeric":"The :attribute must be between :min and :max.","string":"The :attribute must be between :min and :max characters."},"boolean":"The :attribute field must be true or false.","confirmed":"The :attribute confirmation does not match.","custom":{"attribute-name":{"rule-name":"custom-message"}},"date":"The :attribute is not a valid date.","date_format":"The :attribute does not match the format :format.","different":"The :attribute and :other must be different.","digits":"The :attribute must be :digits digits.","digits_between":"The :attribute must be between :min and :max digits.","dimensions":"The :attribute has invalid image dimensions.","distinct":"The :attribute field has a duplicate value.","email":"The :attribute must be a valid email address.","exists":"The selected :attribute is invalid.","file":"The :attribute must be a file.","filled":"The :attribute field must have a value.","image":"The :attribute must be an image.","in":"The selected :attribute is invalid.","in_array":"The :attribute field does not exist in :other.","integer":"The :attribute must be an integer.","ip":"The :attribute must be a valid IP address.","ipv4":"The :attribute must be a valid IPv4 address.","ipv6":"The :attribute must be a valid IPv6 address.","json":"The :attribute must be a valid JSON string.","max":{"array":"The :attribute may not have more than :max items.","file":"The :attribute may not be greater than :max kilobytes.","numeric":"The :attribute may not be greater than :max.","string":"The :attribute may not be greater than :max characters."},"mimes":"The :attribute must be a file of type: :values.","mimetypes":"The :attribute must be a file of type: :values.","min":{"array":"The :attribute must have at least :min items.","file":"The :attribute must be at least :min kilobytes.","numeric":"The :attribute must be at least :min.","string":"The :attribute must be at least :min characters."},"not_in":"The selected :attribute is invalid.","numeric":"The :attribute must be a number.","present":"The :attribute field must be present.","regex":"The :attribute format is invalid.","required":"The :attribute field is required.","required_if":"The :attribute field is required when :other is :value.","required_unless":"The :attribute field is required unless :other is in :values.","required_with":"The :attribute field is required when :values is present.","required_with_all":"The :attribute field is required when :values is present.","required_without":"The :attribute field is required when :values is not present.","required_without_all":"The :attribute field is required when none of :values are present.","same":"The :attribute and :other must match.","size":{"array":"The :attribute must contain :size items.","file":"The :attribute must be :size kilobytes.","numeric":"The :attribute must be :size.","string":"The :attribute must be :size characters."},"string":"The :attribute must be a string.","timezone":"The :attribute must be a valid zone.","unique":"The :attribute has already been taken.","uploaded":"The :attribute failed to upload.","url":"The :attribute format is invalid."},"pt-BR.auth":{"blocked":"Usu\u00e1rio Bloqueado. Entre em contato com o Administrador para desbloquear.","expired":"Informe novamente suas credenciais para continuar utilizando o sistema.","failed":"Essas credenciais n\u00e3o correspondem aos nossos registros.","logout_success":"Logout bem-sucedido.","throttle":"Muitas tentativas de login. Tente novamente em :seconds segundos.","unauthenticated":"Usu\u00e1rio n\u00e3o autenticado","unauthorized":"Acesso n\u00e3o autorizado"},"pt-BR.business":{"consulta_previa_RU":{"validade_expirada_RU":"N\u00famero da consulta pr\u00e9via de viabilidade refere-se a uma consulta fora da validade."},"consulta_previa_ambiental":{"codigos_invalidos":"N\u00e3o foi encontrada consulta pr\u00e9via ambiental para os n\u00fameros de consulta de viabilidade e consulta pr\u00e9via informados.","validade_expirada":"N\u00famero da consulta pr\u00e9via ambiental refere-se a uma consulta fora da validade."},"file_not_found":"Arquivo n\u00e3o encontrado","not_found":"Valor informado para :attribute n\u00e3o corresponde a nenhum registro"},"pt-BR.pagination":{"next":"Pr\u00f3ximo &raquo;","no_records":"Nenhum registro encontrado","previous":"&laquo; Anterior"},"pt-BR.passwords":{"password":"As senhas devem ter no m\u00ednimo seis caracteres e combinar a confirma\u00e7\u00e3o.","reset":"Sua senha foi redefinida!","sent":"Enviamos seu link de redefini\u00e7\u00e3o de senha por e-mail!","token":"Este token de redefini\u00e7\u00e3o de senha \u00e9 inv\u00e1lido.","user":"N\u00e3o encontramos um usu\u00e1rio com esse endere\u00e7o de e-mail."},"pt-BR.validation":{"accepted":"O campo :attribute deve ser aceito.","active_url":"O campo :attribute deve ser uma URL v\u00e1lida.","after":"O campo :attribute deve ser uma data depois :date.","after_or_equal":"O campo :attribute deve ser uma data posterior ou igual a :date.","alpha":"O campo :attribute deve conter somente letras.","alpha_dash":"O campo :attribute deve conter somente letras, n\u00fameros e tra\u00e7os.","alpha_num":"O campo :attribute deve conter somente letras e n\u00fameros.","and":"E","array":"O campo :attribute deve ser uma lista.","attributes":{"area_venda":"\u00c1rea de vendas","bairro":"Bairro","capacidade_publico":"Capacidade de p\u00fablico","captcha_token":"N\u00e3o sou um rob\u00f4","categoria":"Categoria","celular":"Celular","cep":"CEP","cidade":"Cidade","cnpj":"CNPJ","cod_consulta_previa":"N\u00famero da consulta de viabilidade","cod_consulta_previa_ambiental":"N\u00famero da consulta pr\u00e9via ambiental","cod_requerimento":"N\u00famero do requerimento","complemento":"Complemento","confirmar_senha":"Confirmar senha","cpf":"CPF","cpf_cnpj":"CPF\/CNPJ","data_envio":"Data de envio","data_validade":"Data de validade","descricao":"Descri\u00e7\u00e3o","diretriz_parcelamento":"Possui Diretriz de Parcelamento?","email":"E-mail","id_endereco":"Endere\u00e7o","id_requerimento_olei":"Requerimento OLEI","id_tipo_logradouro":"Tipo de logradouro","identificacao_intervencao":"Identifica\u00e7\u00e3o da \u00e1rea de interven\u00e7\u00e3o","indice_cadastral":"\u00cdndice cadastral (IPTU)","iptu":"IPTU","letra":"Letra","logradouro":"Logradouro","lote_ctm":"Lote CTM","nome":"Nome","nome_empreendedor":"Nome do empreendedor","nome_empreendimento":"Nome do empreendimento","nome_fantasia":"Nome Fantasia","nome_logradouro":"Logradouro","nome_razao_social":"Nome\/Raz\u00e3o social","nome_regra":"Nome da Regra","num_registro_orgao_classe":"Registro Profissional","numero":"N\u00famero","ocupacao_profissional":"Profiss\u00e3o","operador":"Funcion\u00e1rio","protocolo_siasp":"N\u00famero do protocolo SIASP da concess\u00e3o da Diretriz de Parcelamento","renovacao_licenca":"Renova\u00e7\u00e3o de licen\u00e7a?","rt":"Respons\u00e1vel T\u00e9cnico","senha":"Senha","telefone":"Telefone","termo":"Termo de responsabilidade","tipo_ocupacao":"Tipo de ocupa\u00e7\u00e3o","tipo_parcelamento":"Tipo de parcelamento","tipos_infraestrutura":"Tipos de infraestrutura","uf":"UF"},"before":"O campo :attribute deve ser uma data anterior a :date.","before_or_equal":"O campo :attribute deve ser uma data anterior ou igual a :date.","between":{"array":"O campo :attribute deve ter entre :min e :max itens.","file":"O campo :attribute deve ser entre :min e :max kilobytes.","numeric":"O campo :attribute deve ser entre :min e :max.","string":"O campo :attribute deve ser entre :min e :max caracteres."},"boolean":"O campo :attribute deve ser verdadeiro ou falso.","captcha":"Verifica\u00e7\u00e3o \":attribute\" falhou.","cep":"O campo :attribute tem um valor inv\u00e1lido","cnpj":"O campo :attribute deve ser um documento v\u00e1lido.","confirmed":"O campo :attribute de confirma\u00e7\u00e3o n\u00e3o confere.","cpf":"O campo :attribute deve ser um documento v\u00e1lido.","cpf_cnpj":"O campo :attribute deve ser um documento v\u00e1lido.","custom":{"attribute-name":{"rule-name":"custom-message"}},"date":"O campo :attribute n\u00e3o \u00e9 uma data v\u00e1lida.","date_format":"O campo :attribute n\u00e3o corresponde ao formato :format.","decimal":"O campo :attribute deve ser um n\u00famero com at\u00e9 :precisao casas decimais.","different":"O campo :attribute deve ter um valor diferente do campo :other.","digits":"O campo :attribute deve ter :digits d\u00edgitos.","digits_between":"O campo :attribute deve ter entre :min e :max d\u00edgitos.","dimensions":"O campo :attribute tem dimens\u00f5es de imagem inv\u00e1lidas.","distinct":"O campo :attribute campo tem um valor duplicado.","email":"O campo :attribute deve ser um endere\u00e7o de e-mail v\u00e1lido.","empty":"O campo :attribute n\u00e3o deve ser informado.","empty_if":"O campo :attribute n\u00e3o deve ser informado quando :other \u00e9 :value.","empty_unless":"O campo :attribute n\u00e3o deve ser informado exceto quando :other seja :values.","erros_dest":"Verifique os erros destacados.","exists":"O campo :attribute selecionado \u00e9 inv\u00e1lido.","expressao":"O campo :attribute n\u00e3o \u00e9 uma express\u00e3o v\u00e1lida.","file":"O campo :attribute deve ser um arquivo.","filled":"O campo :attribute o campo deve ter um valor.","hour":"O campo :attribute n\u00e3o \u00e9 uma hora v\u00e1lida.","image":"O campo :attribute deve ser uma imagem.","in":"O campo :attribute selecionado \u00e9 inv\u00e1lido.","in_array":"O campo :attribute deve existir em :other.","integer":"O campo :attribute deve ser um n\u00famero inteiro.","invalid":"O valor informado para o campo :attribute n\u00e3o \u00e9 v\u00e1lido.","ip":"O campo :attribute deve ser um endere\u00e7o de IP v\u00e1lido.","iptu":"O IPTU :attribute \u00e9 inv\u00e1lido","ipv4":"O campo :attribute deve ser um endere\u00e7o IPv4 v\u00e1lido.","ipv6":"O campo :attribute deve ser um endere\u00e7o IPv6 v\u00e1lido.","json":"O campo :attribute deve ser uma string JSON v\u00e1lida.","max":{"array":"O campo :attribute n\u00e3o pode ter mais do que :max itens.","file":"O campo :attribute n\u00e3o pode ser superior a :max kilobytes.","numeric":"O campo :attribute n\u00e3o pode ser superior a :max.","string":"O campo :attribute n\u00e3o pode ter mais de :max caracteres."},"mimes":"O campo :attribute deve ser um arquivo de tipo: :values.","mimetypes":"Tipos de arquivo aceitos para o campo :attribute: :values.","min":{"array":"O campo :attribute deve ter pelo menos :min itens.","file":"O campo :attribute deve ter pelo menos :min kilobytes.","numeric":"O campo :attribute deve ser pelo menos :min.","string":"O campo :attribute deve ter pelo menos :min caracteres."},"monetario":"O campo :attribute deve ser preenchido com um valor monet\u00e1rio v\u00e1lido.","not_in":"O campo :attribute selecionado \u00e9 inv\u00e1lido.","numeric":"O campo :attribute deve ser um n\u00famero.","or":"OU","positivo":"O campo :attribute \u00e9 obrigat\u00f3rio.","present":"O campo :attribute deve estar presente.","protocolo_siasp":"O campo :attribute n\u00e3o tem um formato v\u00e1lido.","regex":"O campo :attribute tem um formato inv\u00e1lido.","required":"O campo :attribute \u00e9 obrigat\u00f3rio.","required_if":"O campo :attribute \u00e9 obrigat\u00f3rio quando :other \u00e9 :value.","required_unless":"O campo :attribute \u00e9 obrigat\u00f3rio exceto quando :other seja :values.","required_with":"O campo :attribute \u00e9 obrigat\u00f3rio se for informado :values.","required_with_all":"O campo :attribute \u00e9 obrigat\u00f3rio se for informado :values.","required_without":"O campo :attribute \u00e9 obrigat\u00f3rio se n\u00e3o for informado :values.","required_without_all":"O campo :attribute \u00e9 obrigat\u00f3rio se n\u00e3o for informado :values.","same":"O campo :attribute deve ter o mesmo valor do campo :other.","size":{"array":"O campo :attribute deve conter :size itens.","file":"O campo :attribute deve ter :size kilobytes.","numeric":"O campo :attribute deve ser :size.","string":"O campo :attribute deve ter :size caracteres."},"string":"O campo :attribute deve ser uma string.","timezone":"O campo :attribute deve ser uma zona v\u00e1lida.","unique":"O valor informado para o campo :attribute j\u00e1 est\u00e1 sendo utilizado. Escolha outro valor.","uploaded":"O campo :attribute falha no upload.","url":"O campo :attribute deve ser uma URL v\u00e1lida."}};

    moment.locale(constantes.LOCALE);


    var queryString = function (paramsObj) {
        return Object.keys(paramsObj).map(function (key) {
            if(typeof paramsObj[key] === 'object') {
                if(Array.isArray(paramsObj[key]))
                    { return paramsObj[key].map(function (item) { return key + '[]=' + item; }).join('&'); }
                else
                    { throw new 'Os atributos de uma query string devem ser valores primitivos ou arrays simples'; }
            } else
                { return key + '=' + paramsObj[key] }
        }).join('&');
    };

    var formatUrl = function (value) {
        return value 
            ? value.toLowerCase()
            // faz as substituições dos acentos
            .replace(/[á|ã|â|à]/gi, "a")
            .replace(/[é|ê|è]/gi, "e")
            .replace(/[í|ì|î]/gi, "i")
            .replace(/[õ|ò|ó|ô]/gi, "o")
            .replace(/[ú|ù|û]/gi, "u")
            .replace(/[ç]/gi, "c")
            .replace(/[ñ]/gi, "n")
            // remove caracteres de espaçamento
            .replace(/\W+/gi, "-")
            : ''
    };

    /**
     * Converte um objeto em um array de mensagens
     * @param {(String|Array|Object)} response que pode ser:
     *  Uma string com a mensagem; OU um array de strings; OU um objeto response/error response do axios
    */
    var getMsg = function (obj) {
        var msgs = typeof obj === 'object'
            ? Array.isArray(obj)
                ? obj //array
                : obj.response  //error response
                    ? obj.response.data
                        ? obj.response.data.errors //error response regular
                            ? typeof obj.response.data.errors === 'object' ? _.flatten(Object.values(obj.response.data.errors)) : [''+obj.response.data.errors]
                            : [obj.response.statusText+': '+obj.response.data.message] 
                        : [obj.toString()] //error response mal formada
                    : obj.data //response
                        ? [obj.data] //response regular
                        : [obj.toString()] //response mal formada
            : [__(''+obj)];//string
        return msgs;
    };

    /**
     * Retorna uma tradução (método lang.get), mas aponta automaticamente para mensagems de 'validation' caso não seja especificado o arquivo
     * @param {String} key chave da mensagem no arquivo de tradução. <nome arquivo>.<nome_chave>[.</nome_chave>]
     * @param {Object} args parâmetros da mensagem
     * @param {String} fallback (opcional) string retornada caso não seja encontrada a mensagem
     */
    var __ = function (key, args, fallback) {
        var chave = key.match(/^(?:validation|business|pagination|passwords|auth)\..+/) ? key : 'validation.'+key;
        return lang.has(chave) ? lang.get(chave, args) : (fallback===undefined ? key : fallback);
    };

    /**
     * Apresenta uma mensagem para o usuário
     * @param {Object} comp Instância do componente vue
     * @param {String|Array|Object} msg Mensagem(ens) que serão apresentadas, pode ser qualquer valor aceito por getMsg()
     * @param {Object} options {
     * * {String} ref identifica qual componente apresentará a mensagem, não é necessário se a mensagem for somente toast ou se o form tiver setado msgRef
     * * {String} variant (opcional, default: 'warning') classe contextual da mensagem: success, error,  warning, info, primary
     * * {boolean} box (opcional, default: true, se 'dialog' e 'toast' forem false, senão false) Se a mensagem deve ser apresentada na caixa de mensagem ou não
     * * {object|boolean} dialog (opcional, default: false) Um objeto com os parâmetros de dialog, ou um boolean: true exibe dialog com valores padrão, false, não exibe dialog.
     *                  Os parâmetro aceitos são os mesmos do Toast do botstrap-vue
     * * {object|boolean} toast (opcional, default: false) Um objeto com os parâmetros de toast ou um boolean: true exibe toast com valores padrao, false, não exibe toast.
     *                  Os parâmetro aceitos são os mesmos do Modal programático do botstrap-vue
     * * {object|boolean} scroll (opcional, default: false) Um objeto com os parâmetros do scroll (ver método scrollTo), ou false, se não quiser deslizar com scroll. Default {container: 'body', alvo: '#app'}.
     *                    Ignora scroll se box = false
     * * {boolean} limpar (opcional, default: true) Se deve limpar as mensagens anteriores registradas no store ou não
     * }
    */
    var printMsg = function (comp, msg, ref$1) {
        if ( ref$1 === void 0 ) ref$1 = {};
        var ref = ref$1.ref;
        var box = ref$1.box;
        var variant = ref$1.variant; if ( variant === void 0 ) variant = "warning";
        var scroll = ref$1.scroll; if ( scroll === void 0 ) scroll = true;
        var dialog = ref$1.dialog; if ( dialog === void 0 ) dialog = false;
        var toast = ref$1.toast; if ( toast === void 0 ) toast = false;
        var limpar = ref$1.limpar; if ( limpar === void 0 ) limpar = true;

        ref = ref || comp.msgRef;
        var msgs = getMsg(msg);
        if(ref && limpar) { comp.$store.dispatch('flushMsgs',  ref); }
        var retorno = {msg: msgs};
        //se não definiu dialog nem toast, box é exibida mesmo que não tenha sido definida
        if(box===undefined && !dialog && !toast) { box = true; } 

        //exibe box
        if(box && msgs.length) {
            if(typeof ref === "undefined")
                { throw 'printMsg(): Para apresentar uma mensagem em box, é necessário especificar a ref do componente' }

            comp.$store.dispatch('addMsgs', {ref: ref, msg: msgs, variant: variant});
            
            if(scroll) {
                comp.$nextTick(function () { 
                    scrollTo(comp, (typeof scroll === 'object' ? scroll : { el: '#'+ref }));
                });
            }
        }

        if(toast || dialog) {
            var conteudo = '', title = '';
            //se forem múltiplas mensagens
            if(msgs.length > 1) {
                //organiza como uma lista
                conteudo = comp.$createElement('ul', msgs.map(function (msg) { return comp.$createElement('li', {  domProps: {innerHTML: msg} }); }));
                title = 'Atenção';
            } else {
                conteudo = comp.$createElement('div', { domProps: { innerHTML: msgs[0] } });
                title = 'Confirme';
            }
            
            //exibe toast
            if(toast && comp.$bvToast) {
                comp.$bvToast.toast(conteudo, Object.assign({ 
                    variant: variant,
                    toaster: 'b-toaster-'+(toast.position || 'top-right'),
                    solid: true,
                }, toast));
            }
            
            //exibe dialog
            if(dialog && comp.$bvModal) {
                var acao = (typeof dialog === 'object' && dialog.acao) 
                    ? dialog.acao.substring(0, 1).toUpperCase() + dialog.acao.substring(1).toLowerCase()
                    : 'Ok';
                var v = dialog.variant ? dialog.variant : variant;
                if(typeof comp.$bvModal['msgBox'+acao] !== 'function')
                    { throw ("printMsg(): A ação \"" + acao + "\" não está disponível para dialog. Permitido somente 'Ok' e 'Confirm'"); }
                var exigeConfirmacao = acao === 'Confirm';
        
                retorno.dialog = comp.$bvModal['msgBox'+acao](conteudo, Object.assign({
                    title: title,
                    cancelTitle: 'Cancelar',
                    headerBgVariant: v,
                    okVariant: v,
                    noCloseOnBackdrop: exigeConfirmacao,
                    noCloseOnEsc: exigeConfirmacao,
                }, dialog));
            }
        }

        return retorno;
    };

    /**
     * Desliza a barra de rolagem para a posição informada
     * @param {Object} obj Objeto Vue que sofrerá a ação
     * @param {Object} (optional) options
    */
    var scrollTo = function (obj, options) {
        if ( options === void 0 ) options = null;

        if (typeof obj === 'object') {
            var opt = Object.assign({container: "body", el: '#app', duration: 500, easing: "linear"}, options);
            obj.$scrollTo(opt.el, opt.duration, opt);
        }
    };

    var stringToDate = function (value) {
        return value ? moment(String(value)) : null;
    };

    var lang = new Lang({
        messages: messages,
        locale: constantes.LOCALE,
        fallback: 'en'
    });

    /**
     * Converte caracteres especiais específicos do Microsoft Word nos equivalentes em UTF-8
    */
    var removeFormatacaoWord = function (text) {
    	return text
    		.replace(/[\u2018|\u2019|\u201A]/g, "\'")
    		.replace(/[\u201C|\u201D|\u201E]/g, "\"")
    		.replace(/\u2026/g, "...")
    		.replace(/[\u2013|\u2014]/g, "-")
    		.replace(/\u02C6/g, "^")
    		.replace(/\u2039/g, "<")
    		.replace(/\u203A/g, ">")
            .replace(/\u02DC/g, "~")
            .replace(/\u00A0/g, " ");
    };

    /**
     * Motifica uma lista de options acrescentando a prop html com o mesmo valor de text
     */
    var htmlOptions = function (obj, textKey) {
        if ( textKey === void 0 ) textKey = 'text';

        return obj.map(function (option) { 
            option.html = option[textKey];
            return option;
        });
    };

    /**
     * Formata o conteúdo inserindo ícones de classes de contexto.
     * (Esse método não é exportado. Usado internamente pelos métodos $confirm e $alert)
     */
    var formataConteudo = function (vm, conteudo, variant, showIcon) {
        var conteudo_html = '';
        if(!Array.isArray(conteudo)) {
            conteudo_html = String(conteudo);
        } else {
            conteudo_html = (conteudo.length === 1) 
                ? String(conteudo[0]) // Lista de um item não é tratada como lista
                : '<ul><li>' + conteudo.join('</li><li>') + '</li></ul>';
        }

        if(showIcon && constantes.icon[variant]) {
            var icon_class = 'fa fa-3x'+(constantes.icon[variant] ?' fa-'+constantes.icon[variant]+' text-'+variant : '');
            conteudo_html = "\n        <div class=\"row\">\n            <div class=\"col-2 col-xs-3 align-self-center text-center\">\n                <i class=\"" + icon_class + "\"></i>\n            </div>\n            <div class=\"col align-self-center\">\n                " + conteudo_html + "\n            </div>\n        </div>";
        }

        return vm.$createElement('div', { domProps: { innerHTML: conteudo_html } });
    };

    var $confirm = function(params) {
        var variant = params.variant || "warning";
        var options = Object.assign({
            message: '',
            title: 'CONFIRME',
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar',
            headerBgVariant: variant,
            okVariant: variant,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            showIcon: true,
        }, (typeof params === 'object' && !Array.isArray(params)) ? params : {message: params});

        var conteudo = formataConteudo(this, options.message, variant,  options.showIcon);

        return this.$bvModal.msgBoxConfirm(conteudo, options)
            .then(function (response) {
                if(response) {
                    if(typeof params.onConfirm === 'function')
                        { params.onConfirm(); }
                } else {
                    if(typeof params.onCancel === 'function')
                        { params.onCancel(); }
                }
                return Promise.resolve(response);
            });
    };

    var $alert = function(params){
        var variant = params.variant || "warning";
        var options = Object.assign({
            message: '',
            title: 'ATENÇÃO',
            okOnly: true,
            okTitle: 'OK',
            headerBgVariant: variant,
            okVariant: variant,
            showIcon: true,
        }, (typeof params === 'object' && !Array.isArray(params)) ? params : {message: params});

        var conteudo = formataConteudo(this, options.message, variant,  options.showIcon);

        return this.$bvModal.msgBoxOk(conteudo, options)
            .then(function (response) {
                if(typeof params.onConfirm === 'function')
                    { params.onConfirm(); }
                return Promise.resolve(response);
            });
    };

    /**
     * Exibe um arquivo para o usuário. Se for imagem abre em um modal, senão abre em uma nova aba.
     * 
     * @param {Object} arquivo Objeto do tipo Arquivo (representação de arquivos armazenados em storage)
     * @param {String} titulo_modal (Opcional) Título do modal caso seja uma imagem. Se não informar, será o nome original do arquivo
     * 
     * Para utilizar esse método para exibir imagems, é necessário dar bind no contexto do componente para ter acesso à função de modal.
     */
    var visualizaArquivo = function(arquivo, titulo_modal) {
        if ( titulo_modal === void 0 ) titulo_modal = null;

        //arquivos de imagem são visualizados diretamente através do modal
        if(arquivo.mimetype.indexOf("image") === 0) {
            this.$alert({
                message: ("<img  src=\"" + (constantes.BASE_URL) + "/api/arquivos/" + (arquivo.nome_minio) + "\" class=\"img-fluid\" />"),
                variant: 'primary',
                showIcon: false,
                title: titulo_modal || arquivo.nome_original,
                size: "lg",
            });
        } 
        //outros tipo de arquivo são abertos em uma nova aba para que o navegador decida se é capaz de visualizar ou se deve fazer download
        else {
            window.open(((constantes.BASE_URL) + "/api/arquivos/" + (arquivo.nome_minio) + "/" + (arquivo.nome_original)), "_blank");
        }
    };

    var helpers = { __: __, formatUrl: formatUrl, getMsg: getMsg, lang: lang, printMsg: printMsg, queryString: queryString, scrollTo: scrollTo, stringToDate: stringToDate, removeFormatacaoWord: removeFormatacaoWord, $alert: $alert, $confirm: $confirm, htmlOptions: htmlOptions, visualizaArquivo: visualizaArquivo };

    var store = {
        state: {
            msgs: {},
        },
        mutations: {
            add_msgs: function add_msgs(state, ref$1) {
                var ref = ref$1.ref;
                var msg = ref$1.msg;
                var variant = ref$1.variant;

                msg = helpers.getMsg(msg);
                if(msg.length) {
                    if(!state.msgs[ref])
                        { Vue.set(state.msgs, ref, {}); }
                    //obtém as mensagens da referida caixa de mensagem para a classe de contexto (variant)
                    var msgs = state.msgs[ref][variant] || [];
                    //adiciona as novas mensagens 
                    Vue.set(state.msgs[ref], variant, _.concat(msgs, msg));
                }
            },
            flush_msgs: function flush_msgs(state, ref$1) {
                var ref = ref$1.ref;
                var variant = ref$1.variant;

                var msgs = state.msgs[ref];
                if(msgs) {
                    if(variant) { Vue.delete(state.msgs[ref], variant); }//de uma classe específica
                    else { Vue.delete(state.msgs, ref); }//de todas as classes
                }
            }
        },
        actions: {
            addErro: function addErro(ref$1, ref$2) {
                var commit = ref$1.commit;
                var ref = ref$2.ref;
                var msg = ref$2.msg;
                var variant = ref$2.variant; if ( variant === void 0 ) variant = "warning";

                commit('add_msgs', {ref: ref, msg: msg, variant: variant});
            },
            addSucesso: function addSucesso(ref$1, ref$2) {
                var commit = ref$1.commit;
                var ref = ref$2.ref;
                var msg = ref$2.msg;
                var variant = ref$2.variant; if ( variant === void 0 ) variant = "success";

                commit('add_msgs', {ref: ref, msg: msg, variant: variant});
            },
            addMsgs: function addMsgs(ref$1, ref$2) {
                var commit = ref$1.commit;
                var ref = ref$2.ref;
                var msg = ref$2.msg;
                var variant = ref$2.variant; if ( variant === void 0 ) variant = "info";

                commit('add_msgs', {ref: ref, msg: msg, variant: variant});
            },
            flushErro: function flushErro(ref$1, ref) {
                var commit = ref$1.commit;

                commit('flush_msgs', {ref: ref, variant: 'warning'});
            },
            flushSucesso: function flushSucesso(ref$1, ref) {
                var commit = ref$1.commit;

                commit('flush_msgs', {ref: ref, variant: 'success'});
            },
            flushMsgs: function flushMsgs(ref, obj) {
                var commit = ref.commit;

                obj = typeof obj === 'object' ? obj : {ref: ''+obj};
                commit('flush_msgs', obj);
            },
        },
        getters: {
            msgs: function (state, getters) { return state.msgs; },
            msgsByRef: function (state, getters) { return function (ref, variant) {
                if ( variant === void 0 ) variant = null;

                return state.msgs[ref]
                ? (variant ? state.msgs[ref][variant] : state.msgs[ref])
                : null
            }; },
        }
    };

    //a exportação default instala todos os plugins e registra os componentes básicos (alguns componentes são de uso dos plugin, por isso não são instalados)
    var index = {
        install: function install(Vue, options) {
            //'plugins', 'components', 'helpers', 'filters': aceitam boolean (se deve inserir tudo ou nada) ou um array com os nomes dos itens que serão usados
            //'methods': deve ser um array com os nomes do 'helpers' ou 'filters' que serão aplicados na raiz de todos os componentes. Recomendado usar de forma restrita
            //'lang': boolean, se deve inserir ou não a prop 'lang' no protótipo.
            //'merge': Object, onde cada chave é um objeto que será mesclado com outra propriedade: 'helpers', 'filters', 'methods'. Por padrão não mescla nada.
            var opt = Object.assign({
                //plugins: true,
                components: true,
                helpers: true,
                filters: true,
                lang: true,
                methods: ['printMsg', '__'],
                merge: {},
            }, options);

            //COMPONENTES
            if(opt.components) {
                var components = {
                    alert: alert,
                    autocomplete: autocomplete,
                    autocompletelist: autocompletelist,
                    circuloprogresso: circuloprogresso,
                    FormFileMultiplo: FormFileMultiplo,
                    Grid: Grid,
                    InputDate: InputDate,
                    InputDecimal: InputDecimal,
                    InputModalConsulta: InputModalConsulta,
                    InputMoney: InputMoney,
                    msgs: msgs,
                    ModalConsulta: ModalConsulta,
                    ModalPDF: ModalPDF,
                    PickList: PickList,
                    progresso: progresso,
                    secaoEditavel: secaoEditavel,
                    TableConsulta: TableConsulta,
                    timeline: timeline,

                    topo: topo,
                    menuHorizontal: menuHorizontal,
                    rodape: rodape,
                };
                components = Array.isArray(opt.components) ? _.pick(components, opt.components) : components;
                
                _.each(components, function (plugin, nome) {
                    Vue.component(nome, plugin);
                });
            }
            
            //FILTERS
            if(opt.filters) {
                var filtros = Array.isArray(opt.filters) ? _.pick(filters, opt.filters) : filters;
                //verifica se optou por mesclar com filtros específicos da aplicação
                if(typeof opt.merge.filters === 'object')
                    { filtros = Object.assign(filtros, opt.merge.filters); }
                //registra os filters
                for(var i in filtros) { Vue.filter(i, filtros[i]); }
                Vue.prototype.$filter = filtros;
            }

            //HELPERS
            if(opt.helpers) {
                var funcoes = Array.isArray(opt.helpers) ? _.pick(helpers, opt.helpers) : helpers;
                //verifica se optou por mesclar com helpers específicos da aplicação
                if(typeof opt.merge.helpers === 'object')
                    { Vue.prototype.$helper = Object.freeze(Object.assign(funcoes, opt.merge.helpers)); }
                else
                    { Vue.prototype.$helper = funcoes; }
            }

            //METHODS (disponíveis na raiz de todos os componentes)
            if(Array.isArray(opt.methods)) {
                var methods = _.pick(Object.assign({}, helpers, filters, {
                    //Por padrão, abrevia o helper printMsg omitindo o parâmetro 'comp' (aponta sempre para o próprio componente)
                    printMsg: function(msg, opt) { return helpers.printMsg(this, msg, opt) },
                }), opt.methods);

                if(typeof opt.merge.methods === 'object')
                    { methods = Object.assign(methods, opt.merge.methods); }
                
                Vue.mixin({ methods: methods });
            }

            //funções de manipulação de traduções (pacote 'lang' mariuzzo)
            if(opt.lang)
                { Vue.prototype.$lang = helpers.lang; }

            if(options.store) {
                options.store.registerModule('piweb-store', store);
            }
        }

    };

    exports.FormFileMultiplo = FormFileMultiplo;
    exports.Grid = Grid;
    exports.InputDate = InputDate;
    exports.InputDecimal = InputDecimal;
    exports.InputModalConsulta = InputModalConsulta;
    exports.InputMoney = InputMoney;
    exports.ModalConsulta = ModalConsulta;
    exports.ModalPDF = ModalPDF;
    exports.PickList = PickList;
    exports.TableConsulta = TableConsulta;
    exports.alert = alert;
    exports.autocomplete = autocomplete;
    exports.autocompletelist = autocompletelist;
    exports.circuloprogresso = circuloprogresso;
    exports.default = index;
    exports.filters = filters;
    exports.helpers = helpers;
    exports.menuHorizontal = menuHorizontal;
    exports.msgs = msgs;
    exports.progresso = progresso;
    exports.rodape = rodape;
    exports.secaoEditavel = secaoEditavel;
    exports.timeline = timeline;
    exports.topo = topo;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
